<template>
  <div class="animated revealUp" style="zoom: 0.9">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("fnbitems") }}
      </div>
      <router-link class="btn-blue" to="/fnb/fnb-items"
        >{{ $t("fnbitems") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row mx-1">
        <div class="row mx-0  back pt-4 rounded-10">
          <div class="col-lg-2 col-xl-3 align-self-center">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="fnb_item.item_code"
                  name="itemcode"
                  id="itemcode"
                  v-validate="'required|alpha_dash'"
                  disabled
                  v-b-tooltip.hover
                  :title="$t('fnbitems_itemCode_tooltip')"
                />
                <label>{{ $t("code") }}</label>
              </div>
              <!--Tooltip :title="$t('fnbitems_itemCode_tooltip')" /-->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('itemcode')">{{
                errors.first("itemcode")
              }}</span>
            </p>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="fnb_item.item_name"
                  @input="onChangeItemName($event, 'name')"
                  name="itemname"
                  id="itemname"
                  v-validate="'required'"
                  v-b-tooltip.hover
                  :title="$t('itemname')"
                />
                <label>{{ $t("name") }}</label>
              </div>
              <!---Tooltip :title="$t('itemname')" /--->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('itemname')">{{
                errors.first("itemname")
              }}</span>
            </p>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="fnb_item.alternate_lang_item_name"
                  name="alternate_lang_item_name"
                  id="alternate_lang_item_name"
                  v-validate="'required'"
                  v-b-tooltip.hover
                  title="Alternate Lang. Item Name"
                />
                <label>Alt. Item Name</label>
              </div>
              <!---Tooltip :title="$t('itemname')" /--->
            </div>
            <p class="error_message">
              <span
                v-if="submitted && errors.has('alternate_lang_item_name')"
                >{{ errors.first("alternate_lang_item_name") }}</span
              >
            </p>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center">
            <div class="dropdown-curve-container">
              <label :class="fc_parent_label.length > 0 ? 'shift-up' : ''">{{
                $tc("category", 1)
              }}</label>
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :text="fc_parent_label"
                  variant="dropdown-curve"
                  class="w-100"
                  v-b-tooltip.hover
                  :title="$t('fnbitems_foodcategory_tooltip')"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Categories"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchFoodCategories()"
                      v-on:keydown="onSearchFoodCategories()"
                      v-on:search="onSearchFoodCategories()"
                      v-model="searchFoodCategories"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(fc, fcIndex) in ms_food_categories"
                    :key="fcIndex"
                    href="#"
                    @click="
                      fnb_item.fc_id = fc.fc_id;
                      fc_parent_label = fc.fc_category;
                      searchFoodCategories = '';
                      onSearchFoodCategories();
                    "
                    >{{ fc.fc_category }}</b-dropdown-item
                  >
                </b-dropdown>
                <!---Tooltip :title="$t('fnbitems_foodcategory_tooltip')" /--->
              </div>
              <p class="error_message">
                <span v-if="submitted && fc_parent_label.length == 0"
                  >Please Select Food Category.</span
                >
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="fnb_item.item_description"
                  @input="onChangeItemName($event, 'desc')"
                  name="itemdesc"
                  id="itemdesc"
                  v-validate="'required'"
                  v-b-tooltip.hover
                  :title="$t('fnbitems_itemdescription_tooltip')"
                />
                <label>{{ $t("description") }}</label>
              </div>
              <!---Tooltip :title="$t('fnbitems_itemdescription_tooltip')" /--->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('itemdesc')">{{
                errors.first("itemdesc")
              }}</span>
            </p>
          </div>

          <div class="col-lg-2 col-xl-1 align-self-center">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  style="text-align: right"
                  placeholder="."
                  type="number"
                  v-model="fnb_item.fi_order"
                  name="fi_order"
                  id="fi_order"
                  v-validate=""
                />
                <label>{{ "Order" }}</label>
              </div>
            </div>
            <p class="error_message"></p>
          </div>

          <div class="col-lg-3 col-xl-2 align-self-center">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  style="text-align: right"
                  placeholder="."
                  type="number"
                  v-model="fnb_item.item_age_restriction"
                  name="item_age_restriction"
                  id="item_age_restriction"
                  v-validate=""
                />
                <label>{{ "Age Restriction" }}</label>
              </div>
            </div>
            <p class="error_message"></p>
          </div>

          <div class="col-lg-3 col-xl-2 align-self-center d-flex">
            <div class="row">
              <div class="col-12">
                <label class="mb-0 mr-3">{{ $t("Upload image") }}</label>
                <div class="d-flex align-items-center">
                  <!-- <label for="file-selector3" class="file-selector w-100"> -->

                  <button
                    class="fnb-btn-edit"
                    @click.prevent.stop="setModalData(280, 460)"
                  >
                    Choose File
                  </button>

                  <label
                    style="display: none"
                    class="material-file-upload"
                    @click.prevent.stop="setModalData(280, 460)"
                  >
                    <!---Upload File Path--->
                    <!--div class="text-truncate">{{ fnb_item.item_image_url }}</div--->
                    <!---Upload File Path--->
                    <!-- <input
                    v-on:change="setImage($event)"
                    type="file"
                    class="d-none"
                    name="file-selector3"
                    placeholder="Image"
                    id="file-selector3"
                  />-->
                    <ImageGallery
                      v-bind:propImageName="fnb_item.item_name"
                      :img_desc="fnb_item.item_description"
                      :showPercentageLoader="true"
                      v-bind:openModal="showModal"
                      v-bind:set_height="set_height"
                      v-bind:set_width="set_width"
                      v-bind:category="fnb_item.item_is_veg ? 'Veg' : 'Non Veg'"
                      v-bind:menu="'A'"
                      :resetImgData="false"
                      v-b-tooltip.hover
                      :title="
                        `Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
                      "
                    ></ImageGallery>
                  </label>
                  <!--Tooltip
                            :title="
                              `Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
                            "
                          /-->
                  <img
                    width="40"
                    height="40"
                    class="rounded ml-2 mr-2"
                    @click="showFnbImage()"
                    :src="_GetImagePath(fnb_item.item_image_url)"
                    v-if="
                      fnb_item.hasOwnProperty('item_image_url') &&
                        fnb_item.item_image_url
                    "
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    class="rounded ml-2 mr-2"
                    alt="Empty Image"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
                <!-- <p class="error_message">
                  <span v-if="submitted && fnb_item.item_image_url.length == 0"
                    >Please Select Food Image File.</span
                  >
                </p> -->
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-xl-1 align-self-center pl-0">
            <div class="d-flex align-items-center ml-1">
              <b-form-checkbox
                v-model="fnb_item.item_is_active"
                type="checkbox"
                class="j-checkbox mb-3 pb-0"
                checked
              />

              <label class="mb-3 mr-1">{{ $t("active") }}</label>
            </div>
          </div>
        </div>

        <section class="mb-2 col-lg-12 col-xl-12 align-self-center">
          <div class="row bn-tabs-content">
            <div
              class="col-12 d-flex align-items-center mt-2  back rounded-10 py-2 flex-wrap"
              style=""
            >
              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="fnb_item.item_is_veg"
                    @change="onChangeIsVeg($event)"
                    type="checkbox"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                  >
                  </b-form-checkbox>
                  <label class="mb-0">{{ $t("isveg") }}</label>
                </div>
              </div>

              <div
                class="fnb-flag align-self-center"
                v-if="fnb_item.item_is_veg"
              >
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="fnb_item.includes_egg"
                    style="padding-bottom: 0px"
                    type="checkbox"
                    class="j-checkbox"
                  >
                  </b-form-checkbox>
                  <label class="mb-0">{{ $t("includesegg") }}</label>
                </div>
              </div>

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="fnb_item.is_package_item"
                    type="checkbox"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                  >
                  </b-form-checkbox>
                  <label class="mb-0" style="white-space: nowrap">{{
                    $t("isPackageitem")
                  }}</label>
                </div>
              </div>

              <!-- <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.is_sundry"
                    unchecked-value="N"
                    value="Y"
                  >
                  </b-form-checkbox>
                  <label class="mb-0" style="white-space: nowrap">{{
                    $t("isSundry")
                  }}</label>
                </div>
              </div> -->

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    disabled
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.is_combo"
                    unchecked-value="N"
                    value="Y"
                    @change="onClickCombo($event)"
                  >
                  </b-form-checkbox>
                  <span style="white-space: nowrap">{{ $t("isCombo") }}</span>
                </div>
              </div>

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    class="j-checkbox"
                    disabled
                    style="padding-bottom: 0px"
                    v-model="fnb_item.has_modifiers"
                    unchecked-value="N"
                    value="Y"
                    @change="onClickModifier($event)"
                  >
                  </b-form-checkbox>
                  <span style="white-space: nowrap">{{
                    $t("has_modifiers")
                  }}</span>
                </div>
              </div>

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    name="ready_to_serve"
                    id="ready_to_serve"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.ready_to_serve"
                    unchecked-value="N"
                    value="Y"
                  >
                  </b-form-checkbox>
                  <label
                    class="mb-0"
                    for="ready_to_serve"
                    style="white-space: nowrap"
                    >{{ $t("isReadyToServe") }}</label
                  >
                </div>
              </div>

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    name="is_premier_item"
                    id="is_premier_item"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.is_premier_item"
                    unchecked-value="N"
                    value="Y"
                  >
                  </b-form-checkbox>
                  <label
                    class="mb-0"
                    for="is_premier_item"
                    style="white-space: nowrap"
                    >{{ $t("is_premier_item") }}</label
                  >
                </div>
              </div>

              <div class="fnb-flag align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    type="checkbox"
                    name="is_non_sellable_product"
                    id="is_non_sellable_product"
                    class="j-checkbox"
                    style="padding-bottom: 0px"
                    v-model="fnb_item.is_non_sellable_product"
                    unchecked-value="N"
                    value="Y"
                  >
                  </b-form-checkbox>
                  <label
                    class="mb-0 mr-3"
                    for="is_non_sellable_product"
                    style="white-space: nowrap"
                    >{{ $t("is_non_sellable_product") }}</label
                  >
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="col-12 combo-wrapper" v-if="fnb_item.is_combo == 'Y'">
          <div class="row px-0 mt-3" style="gap: 15px">
            <div class="section-title mt-3 mb-4">
              {{ "Combo" }}
            </div>

            <div class="align-self-center mb-2">
              <div class="dropdown-curve-container">
                <label
                  :class="selectedComboCategory.length > 0 ? 'shift-up' : ''"
                  style="font-weight: 600"
                  >{{ "Combo Category" }}</label
                >
                <multiselect
                  :options="ms_food_categories"
                  v-model="selectedComboCategory"
                  :searchable="true"
                  :multiple="true"
                  label="fc_category"
                  track-by="fc_id"
                  style="min-width: 210px"
                  @input="onSelectComboCategories($event, 'select')"
                  @remove="onSelectComboCategories($event, 'remove')"
                ></multiselect>
                <p
                  v-if="submitted && selectedComboCategory.length == 0"
                  class="error_message"
                >
                  Please Select Categories.
                </p>
              </div>
            </div>
            <div
              class="align-items-center d-flex mb-2 font-weight-bold text-primary"
              @click="onAddManualCategory(CinemaIndex)"
            >
              + ADD CATEGORY
            </div>
          </div>

          <div class="row mb-2 ">
            <div
              class="row sec-1 m-2"
              v-for="(singleCinema, CinemaIndex) in CinemaPriceSettings"
              :key="CinemaIndex"
            >
              <div class="col-11">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <!-- SELECT CINEMA -->
                      <div class="col-lg-12 col-xl-3 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              CinemaPriceSettings[CinemaIndex].cinema_id &&
                              String(CinemaPriceSettings[CinemaIndex].cinema_id)
                                .length > 0
                                ? 'shift-up'
                                : ''
                            "
                            style="font-weight: 600"
                            >{{ $tc("cinema", 1) }}</label
                          >
                          <multiselect
                            :options="cinemaListFiltered"
                            v-model="singleCinema.selectedCinemas"
                            :searchable="true"
                            label="cine_name"
                            track-by="cine_id"
                            placeholder=""
                            @input="onDropdownChange($event, CinemaIndex)"
                            :allowEmpty="false"
                            :showLabels="false"
                            :disabled="isRoleID"
                          ></multiselect>
                          <p class="error_message">
                            <span
                              v-if="
                                submitted &&
                                  singleCinema.selectedCinema.length == 0
                              "
                            >
                              Please Select Cinema.
                            </span>
                          </p>
                        </div>
                      </div>

                      <!-- SELECT RECIPE -->
                      <div class="col-lg-4 col-xl-2 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="dropdown-curve-container overFlowHide">
                            <label
                              :class="
                                singleCinema.selected_recipe_name
                                  ? 'shift-up'
                                  : ''
                              "
                            >
                              {{ $t("recipeoptional") }}
                            </label>
                            <multiselect
                              v-model="singleCinema.selected_recipe_name"
                              @remove="
                                onRemoveFnbItem($event, CinemaIndex);
                                fnb_item.recipe_id = null;
                                singleCinema.recipe_label = '';
                              "
                              @select="
                                onSelectFnbItem($event, CinemaIndex);
                                fnb_item.recipe_id = $event.recipe_id;
                                singleCinema.recipe_label = $event.recipe_name;
                              "
                              :placeholder="
                                singleCinema.recipe_label &&
                                singleCinema.recipe_label.length > 0
                                  ? singleCinema.recipe_label
                                  : 'Recipe Optional'
                              "
                              :options="recipes"
                              label="recipe_name"
                              track-by="recipe_id"
                              :value="singleCinema.recipe_name"
                              :multiple="false"
                              :showLabels="true"
                              select-label="Select"
                              deselect-label="Remove"
                              name="selectrecipe"
                              id="selectrecipe"
                              v-b-tooltip.hover
                              :title="$t('fnbitems_tooltip')"
                            />
                          </div>
                        </div>
                        <p class="error_message"></p>
                      </div>

                      <!-- ITEM COST PRICE -->
                      <div class="col-lg-4 col-xl-2 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="."
                              type="number"
                              style="text-align: right"
                              v-model="singleCinema.itemcost_price.costprice"
                              name="costprice"
                              id="costprice"
                            />
                            <label>{{ $t("itemcostprice") }}</label>
                          </div>
                          <!--Tooltip :title="$t('itemcostprice_costPrice')" /-->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('costprice')">{{
                            errors.first("costprice")
                          }}</span>
                        </p>
                      </div>

                      <!-- FNB PRICE -->
                      <div class="col-lg-3 col-xl-2 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="."
                              style="text-align: right"
                              v-model="singleCinema.ratecard.frc_amount"
                              v-on:keyup="
                                onChangeRatecardAmount($event, CinemaIndex)
                              "
                              type="number"
                              name="cardamount"
                              id="cardamount"
                              v-validate="{
                                required: 'required',
                                regex: '[0-9]|[0-9]*\\.[0-9]*$',
                              }"
                            />
                            <label>{{ $t("amount") }}</label>
                          </div>
                          <!--Tooltip :title="$t('tooltip')" /-->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('cardamount')">
                            {{ "Enter Valid Amount" }}
                          </span>
                        </p>
                      </div>

                      <!-- CHARGE SETTING NAME -->
                      <div
                        v-if="singleCinema.cinemaFlag && false"
                        class="col-lg-4 col-xl-3 align-self-center mb-3"
                      >
                        <div
                          class="d-flex align-items-center"
                          v-if="
                            singleCinema.ratecard.frc_pas_setting_name &&
                              singleCinema.ratecard.frc_pas_setting_name
                                .length > 0
                          "
                        >
                          <div class="input-material">
                            <input
                              type="text"
                              :value="
                                singleCinema.ratecard.frc_pas_setting_name
                              "
                              disabled="disabled"
                            />
                            <label class="mb-0 fs-12" style="color: black">{{
                              $t("Charge Setting")
                            }}</label>
                          </div>
                          <!--Tooltip :title="$t('tooltip')" /-->
                        </div>
                        <p class="error_message"></p>
                      </div>

                      <div v-else class="col-lg-4 col-xl-3 align-self-center">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              CinemaPriceSettings[CinemaIndex]
                                .selectedChargeSettingName &&
                              String(
                                CinemaPriceSettings[CinemaIndex]
                                  .selectedChargeSettingName
                              ).length > 0
                                ? 'shift-up'
                                : ''
                            "
                          ></label>
                          <multiselect
                            :options="singleCinema.pas_setting_name_list"
                            :searchable="true"
                            :placeholder="
                              singleCinema.selectedChargeSettingName.length > 0
                                ? singleCinema.selectedChargeSettingName
                                : 'Charge'
                            "
                            label="pas_charge_setting_name"
                            track-by="pas_id"
                            @select="
                              onChangeSettingName($event, $event, CinemaIndex)
                            "
                            :allowEmpty="false"
                            :showLabels="false"
                          ></multiselect>
                          <p class="error_message">
                            <span
                              v-if="
                                submitted &&
                                  singleCinema.selectedChargeSettingName
                                    .length == 0
                              "
                            >
                              Please Select Charge Setting Name.
                            </span>
                          </p>
                        </div>
                        <p class="error_message"></p>
                      </div>

                      <!-- CHARGE SETTINGS -->
                      <div class="col-md-12 col-xl-12 col-lg-12" v-if="false">
                        <div class="col-12">
                          <div class="row">
                            <table
                              class="col-xl-7"
                              v-if="
                                singleCinema &&
                                  singleCinema.cinemaChargesList.length > 0
                              "
                            >
                              <tr
                                v-for="(cinemaCharge,
                                cinemaChargesListIndex) in singleCinema.cinemaChargesList"
                                :key="cinemaChargesListIndex"
                                class="main_border_add"
                              >
                                <td
                                  style="
                                    padding: 4px 10px;
                                    color: black;
                                    font-weight: bold;
                                  "
                                >
                                  {{ cinemaCharge.ct_name }}
                                </td>

                                <td
                                  style="
                                    padding: 4px 10px;
                                    color: black;
                                    font-weight: bold;
                                    text-align: right;
                                  "
                                >
                                  {{ cinemaCharge.pas_charge_value
                                  }}{{
                                    cinemaCharge.pas_is_percentage == "Y"
                                      ? "%"
                                      : ""
                                  }}
                                </td>

                                <td
                                  style="
                                    padding: 4px 10px;
                                    color: black;
                                    font-weight: bold;
                                    text-align: right;
                                  "
                                >
                                  {{
                                    cinemaCharge.cinemacharges
                                      ? cinemaCharge.cinemacharges.toFixed(4)
                                      : 0
                                  }}
                                </td>
                              </tr>

                              <tr class="main_border_add">
                                <td style="padding: 4px 10px">
                                  <span class="font-weight-bold"
                                    >Net Amount:</span
                                  >
                                  <span style="color: black; font-weight: bold"
                                    >{{ currencyData.curr_code }}
                                    {{
                                      singleCinema.ratecard.frc_net_amount.toFixed(
                                        2
                                      )
                                    }}
                                  </span>
                                </td>

                                <td style="padding: 4px 10px">
                                  <span class="font-weight-bold"
                                    >Gross Total:</span
                                  >
                                  <span style="color: black; font-weight: bold"
                                    >{{ currencyData.curr_code }}
                                    {{
                                      singleCinema.ratecard.frc_total_amount.toFixed(
                                        2
                                      )
                                    }}</span
                                  >
                                </td>

                                <td style="padding: 4px 10px">
                                  <span class="font-weight-bold"
                                    >Food Cost %:</span
                                  >
                                  <span
                                    v-if="
                                      singleCinema.ratecard.frc_total_amount
                                    "
                                    style="color: black; font-weight: bold"
                                  >
                                    {{
                                      +parseFloat(
                                        (
                                          singleCinema.itemcost_price
                                            .costprice /
                                          singleCinema.ratecard.frc_total_amount
                                        ).toFixed(4) * 100
                                      ).toFixed(4)
                                    }}%
                                  </span>
                                </td>
                              </tr>
                            </table>

                            <div class="col-md-5 mb-4" v-if="false">
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                                  <label>{{ cinemaCharge.ct_name }}</label>
                                </div>
                              </div>
                              <!-- <p class="error_msg">Invalid Entry</p> -->
                            </div>
                            <div class="col-md-7" v-if="false">
                              <div class="row">
                                <div class="col-md-5">
                                  <div
                                    class="d-flex justify-content-center align-items-center p-3"
                                  >
                                    <label
                                      >{{ cinemaCharge.pas_charge_value
                                      }}{{
                                        cinemaCharge.pas_is_percentage == "Y"
                                          ? "%"
                                          : ""
                                      }}</label
                                    >
                                  </div>
                                </div>
                                <div class="col-md-5">
                                  <div
                                    class="d-flex justify-content-center align-items-center p-3"
                                  >
                                    <label>{{
                                      cinemaCharge.cinemacharges
                                        ? cinemaCharge.cinemacharges.toFixed(4)
                                        : 0
                                    }}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div
                          class="combo-box row"
                          v-for="(category,
                          categoryIndex) in singleCinema.combo_pack"
                          :key="categoryIndex"
                          v-if="singleCinema.combo_pack.length > 0"
                        >
                          <div class="col-md-2 col-sm-6">
                            <div class="d-flex align-items-center">
                              <div class="input-material">
                                <input
                                  type="text"
                                  disabled
                                  style="text-align: right"
                                  v-model="category.category_name"
                                  name="category_name"
                                  id="category_name"
                                />
                                <label>{{ "Category" }}</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-2 col-sm-6">
                            <div class="d-flex align-items-center">
                              <div
                                class="input-material"
                                v-if="category.min_max_setting == 'Y'"
                              >
                                <input
                                  type="number"
                                  style="text-align: right"
                                  v-model="category.min_quantity"
                                  name="min_quantity"
                                  id="min_quantity"
                                />
                                <label>{{ "Min Qty" }}</label>
                              </div>
                              <div
                                class="input-material"
                                v-if="category.min_max_setting == 'Y'"
                              >
                                <input
                                  type="number"
                                  style="text-align: right"
                                  v-model="category.max_quantity"
                                  name="max_quantity"
                                  id="max_quantity"
                                />
                                <label>{{ "Max Qty" }}</label>
                              </div>
                              <div class="input-material" v-else>
                                <input
                                  type="number"
                                  style="text-align: right"
                                  v-model="category.quantity"
                                  name="item_qty"
                                  id="item_qty"
                                />
                                <label>{{ "Quantity" }}</label>
                              </div>
                            </div>
                            <div class="checkbox-box mt-2">
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  type="checkbox"
                                  :name="
                                    `min_max_setting_${categoryIndex}_${CinemaIndex}`
                                  "
                                  :id="
                                    `min_max_setting_${categoryIndex}_${CinemaIndex}`
                                  "
                                  class="j-checkbox"
                                  style="padding-bottom: 0px"
                                  v-model="category.min_max_setting"
                                  unchecked-value="N"
                                  value="Y"
                                >
                                </b-form-checkbox>
                                <label
                                  class="mb-0 mr-3"
                                  :for="
                                    `min_max_setting_${categoryIndex}_${CinemaIndex}`
                                  "
                                  style="white-space: nowrap"
                                  >{{ $t("min_max_setting") }}</label
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <div class="dropdown-curve-container">
                              <label
                                :class="'shift-up'"
                                style="font-weight: 600"
                                >{{ "Item" }}</label
                              >
                              <multiselect
                                :options="
                                  getCategoryItems(
                                    singleCinema,
                                    category.category_id,
                                    category,
                                    null
                                  )
                                "
                                v-model="category.default_item"
                                @select="
                                  onSelectDefaultItem(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'select'
                                  )
                                "
                                @remove="
                                  onSelectDefaultItem(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'remove'
                                  )
                                "
                                :searchable="true"
                                :multiple="false"
                                label="item_name"
                                track-by="item_id"
                              ></multiselect>
                              <p>
                                <span
                                  class="error_message"
                                  v-if="
                                    getCategoryItems(
                                      singleCinema,
                                      category.category_id,
                                      category,
                                      null
                                    ).length == 0 &&
                                      !cinemaLoader &&
                                      !singleCinema.isLoading
                                  "
                                  >No Items For Selected Category</span
                                >
                                <span
                                  class="error_message"
                                  v-else-if="
                                    !category.default_item_id && submitted
                                  "
                                  >Please Select Item</span
                                >
                                <span
                                  class="font-style-italic"
                                  v-else-if="singleCinema.isLoading"
                                  >Loading Items &nbsp;
                                  <b-spinner
                                    v-if="singleCinema.isLoading"
                                    small
                                    variant="dark"
                                    label="Spinning"
                                    class="item-spinner"
                                  ></b-spinner>
                                </span>
                              </p>
                            </div>
                          </div>
                          <div class="col-md-5 col-sm-6">
                            <div class="dropdown-curve-container">
                              <label
                                :class="'shift-up'"
                                style="font-weight: 600"
                                >{{ "Alternate Items" }}</label
                              >
                              <multiselect
                                :options="
                                  getCategoryItems(
                                    singleCinema,
                                    category.category_id,
                                    category,
                                    'alternate'
                                  )
                                "
                                v-model="category.alternate_items"
                                :searchable="true"
                                :multiple="true"
                                label="item_name"
                                track-by="item_id"
                              ></multiselect>
                              <p class="error_message"></p>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="singleCinema.combo_pack.length == 0"
                          class="noCategory"
                        >
                          <span>Please Select Combo Category</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- OLD PRICE BREAKUP -->
                  <div class="col-md-12 col-xl-12 col-lg-12">
                    <div class="col-12">
                      <div class="row">
                        <table
                          class="col-xl-8 border old_price_backup_combo"
                          border
                          v-if="
                            singleCinema.combo_pack &&
                              singleCinema.combo_pack.length > 0 &&
                              singleCinema.combo_pack.some(
                                (x) => x.default_item
                              )
                          "
                        >
                          <tr class="main_border_add bg_light">
                            <td>Item Name</td>
                            <td>Cost Price</td>
                            <td>Net Price</td>
                            <td>Tax Amt.</td>
                            <td>Gross</td>
                          </tr>
                          <tr
                            v-for="(category_obj,
                            itemCIndex) in singleCinema.combo_pack"
                            :key="itemCIndex"
                            class="main_border_add"
                            v-if="category_obj.default_item"
                          >
                            <td>
                              {{
                                category_obj.default_item["item_name"] || "-"
                              }}
                            </td>
                            <td>
                              {{
                                currFormat(
                                  category_obj.default_item["itc_cost_price"]
                                ) || "0.00"
                              }}
                            </td>
                            <td>
                              {{
                                currFormat(
                                  category_obj.default_item["fp_amount"]
                                ) || "0.00"
                              }}
                            </td>
                            <td>
                              {{
                                currFormat(
                                  parseFloat(
                                    category_obj.default_item[
                                      "fp_total_amount"
                                    ] || 0
                                  ) -
                                    parseFloat(
                                      category_obj.default_item["fp_amount"] ||
                                        0
                                    )
                                ) || "0.00"
                              }}
                            </td>
                            <td>
                              {{
                                currFormat(
                                  category_obj.default_item["fp_total_amount"]
                                ) || "0.00"
                              }}
                            </td>
                          </tr>

                          <tr class="main_border_add bg_light">
                            <td>Total</td>
                            <td>
                              {{
                                parseFloat(
                                  singleCinema.combo_pack.reduce(function(
                                    accumulator,
                                    { default_item }
                                  ) {
                                    return (
                                      accumulator +
                                      parseFloat(
                                        default_item["itc_cost_price"] || 0
                                      )
                                    );
                                  },
                                  0)
                                ).toFixed(MIN_FRACTION_DIGITS)
                              }}
                            </td>
                            <td style="padding: 4px 10px">
                              {{
                                parseFloat(
                                  singleCinema.combo_pack.reduce(function(
                                    accumulator,
                                    { default_item }
                                  ) {
                                    return (
                                      accumulator +
                                      parseFloat(default_item["fp_amount"] || 0)
                                    );
                                  },
                                  0)
                                ).toFixed(MIN_FRACTION_DIGITS)
                              }}
                            </td>
                            <td style="padding: 4px 10px">
                              {{
                                parseFloat(
                                  singleCinema.combo_pack.reduce(function(
                                    accumulator,
                                    { default_item }
                                  ) {
                                    return (
                                      accumulator +
                                      parseFloat(
                                        parseFloat(
                                          default_item["fp_total_amount"] || 0
                                        ) -
                                          parseFloat(
                                            default_item["fp_amount"] || 0
                                          )
                                      )
                                    );
                                  },
                                  0)
                                ).toFixed(MIN_FRACTION_DIGITS)
                              }}
                            </td>
                            <td style="padding: 4px 10px">
                              {{
                                parseFloat(
                                  singleCinema.combo_pack.reduce(function(
                                    accumulator,
                                    { default_item }
                                  ) {
                                    return (
                                      accumulator +
                                      parseFloat(
                                        default_item["fp_total_amount"] || 0
                                      )
                                    );
                                  },
                                  0)
                                ).toFixed(MIN_FRACTION_DIGITS)
                              }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- <div
                    class="col-lg-12 col-xl-12 d-flex align-items-center combo-inner-title mt-2"
                  >
                    {{ "Validity" }}
                  </div> -->

                  <!-- FROM DATE -->
                  <div class="col-lg-4 col-xl-2 align-self-center my-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="singleCinema.ms_fnb_price.fp_from_date"
                            @click="resetFromDate(CinemaIndex)"
                          >
                            ✖
                          </button>
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="singleCinema.ms_fnb_price.fp_from_date"
                            name="fdate1"
                            id="fdate1"
                            typeable
                            v-validate="'required'"
                            v-b-tooltip.hover
                            :title="$t('fnbpricing_fromdate')"
                          ></Datepicker>
                          <label
                            :class="
                              typeof singleCinema.ms_fnb_price.fp_from_date ===
                              'object'
                                ? 'active'
                                : ''
                            "
                            >From</label
                          >
                        </div>
                      </div>
                      <!--Tooltip :title="$t('fnbpricing_fromdate')" /-->
                    </div>
                    <p
                      v-if="submitted && errors.has('fdate1')"
                      class="error_message"
                    >
                      {{ errors.first("fdate1") }}
                    </p>
                  </div>

                  <!-- TO DATE -->
                  <div class="col-lg-4 col-xl-2 align-self-center my-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="singleCinema.ms_fnb_price.fp_to_date"
                            @click="resetToDate(CinemaIndex)"
                          >
                            ✖
                          </button>
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="singleCinema.ms_fnb_price.fp_to_date"
                            name="tdate1"
                            id="tdate1"
                            typeable
                            v-b-tooltip.hover
                            :title="$t('fnbpricing_todate')"
                          ></Datepicker>
                          <label
                            :class="
                              typeof singleCinema.ms_fnb_price.fp_to_date ===
                              'object'
                                ? 'active'
                                : ''
                            "
                            >To (Optional)</label
                          >
                        </div>
                      </div>
                    </div>
                    <!--p class="text-muted fs-12">({{ $t("optional") }})</p-->
                  </div>

                  <template v-if="showErpColumns">
                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.report_code"
                            name="report_code"
                            id="report_code"
                            v-validate=""
                          />
                          <label>{{ "Report Code" }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.gl_account"
                            name="gl_account"
                            id="gl_account"
                            v-validate=""
                          />
                          <label>{{ "GL Account" }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.gl_desc"
                            name="gl_desc"
                            id="gl_desc"
                            v-validate=""
                          />
                          <label>{{ "GL Desc." }}</label>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- CHARGE IS INCLUSIVE SWITCH -->
                  <div
                    class="col-lg-3 col-xl-2 align-self-center mb-0 mx-0 p-0"
                  >
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        unchecked-value="N"
                        value="Y"
                        v-model="
                          singleCinema.ratecard.frc_is_active_inclusivtax
                        "
                        name="check-button"
                        @change="OnSwitchHandler($event, CinemaIndex)"
                        class="j-checkbox pb-0 mb-0"
                      ></b-form-checkbox>
                      <label class="mb-0 mr-3">{{ $t("inclusivoftax") }}</label>
                    </div>
                  </div>

                  <!-- DAYS -->
                  <div class="col-lg-12 col-xl-12 pl-0 ml-4 mb-2">
                    <div class="row">
                      <div class="mr-1" style="color: black">
                        {{ $t("days") }}:
                      </div>
                      <!--{{ $t("select") }}-->
                      <b-form-checkbox
                        v-for="(weekdaysLoop,
                        weekdaysKey) in singleCinema.weekDays"
                        :key="weekdaysKey"
                        style="margin: 0px 3px; min-width: 100px"
                        class="j-checkbox mb-1"
                        @change="
                          onChangeWeekdays($event, weekdaysKey, CinemaIndex)
                        "
                        v-model="singleCinema.weekDays[weekdaysKey]"
                      >
                        <div class="text-capitalize">{{ weekdaysKey }}</div>
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-1 d-flex"
                :class="
                  CinemaPriceSettings && CinemaPriceSettings.length > 1
                    ? 'border-left'
                    : ''
                "
              >
                <button
                  v-if="CinemaPriceSettings && CinemaPriceSettings.length > 1"
                  @click.prevent.stop="removeCinemaSettings(CinemaIndex)"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-4 position-relative"
          >
            <button
              @click.prevent.stop="addCinemaSetting()"
              class="btn-transparent add-more-button"
              :disabled="isRoleID"
            >
              <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
            </button>
          </div>

          <section class="mb-2 w-100 px-0 customization-section-new">
            <div
              class="section-title mb-2 d-flex justify-content-between section-collapse-box"
              v-b-toggle.customizationBlock
              style="padding: 6px; align-items: center"
            >
              <span class="fs">
                {{ $t("add") }} {{ $t("customization") }}
              </span>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse
              id="customizationBlock"
              class="mt-2"
              v-model="sectionCollapse.customizationBlock"
            >
              <div v-if="customizationMap.length > 0">
                <div class="row  back mx-0 rounded mb-2">
                  <div class="col-11 pl-0">
                    <div class="col-12 pt-3">
                      <div class="row">
                        <div
                          class="col-lg-6 col-xl-4 align-self-center mb-4"
                          v-for="(customizationSetting,
                          index) in customizationMap"
                          :key="index"
                        >
                          <div class="dropdown-curve-container pr-28px">
                            <label
                              :class="
                                customizationSetting.selectedCustomization
                                  ? 'shift-up'
                                  : ''
                              "
                              >{{ $tc("customization", 1) }}</label
                            >
                            <multiselect
                              :options="customizations"
                              v-model="
                                customizationSetting.selectedCustomization
                              "
                              :searchable="true"
                              label="item_name"
                              track-by="item_id"
                              placeholder="Customization"
                              @select="onSelectCustomisation($event, index)"
                              @remove="onRemoveCustomisation($event, index)"
                              :allowEmpty="true"
                              :showLabels="false"
                            ></multiselect>
                            <p
                              v-if="
                                submitted &&
                                  !customizationSetting.selectedCustomization
                              "
                              class="error_message"
                            >
                              Please Customization.
                            </p>
                          </div>
                        </div>

                        <!-- <div class="col-lg-3 col-xl-4 align-self-center">
                        <div class="d-flex align-items-center mb-4">
                          <span>{{ $t("compulosry") }}</span>
                          <b-form-checkbox
                            class="ml-3"
                            v-model="customizationSetting.is_compulsory"
                            unchecked-value="N"
                            value="Y"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div> -->
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-1 d-flex align-items-center justify-content-center border-left"
                  >
                    <button
                      v-if="index === 0 && false"
                      @click.prevent.stop="addCustomizationSetting($event)"
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                    <button
                      @click.prevent.stop="
                        removeCustomizationSetting(
                          $event,
                          customizationMap.length - 1
                        )
                      "
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row w-100 pl-5">
                  <p class="mx-auto text-muted mb-1">Add Customization</p>
                </div>
              </div>
              <div
                class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
              >
                <button
                  @click.prevent.stop="addCustomizationSetting($event)"
                  class="btn-transparent add-more-button"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </b-collapse>
          </section>
        </section>

        <section
          class="col-12 combo-wrapper"
          v-else-if="fnb_item.has_modifiers == 'Y'"
        >
          <div class="row px-0 mt-3" style="gap: 15px">
            <div class="section-title mt-3 mb-4">
              {{ "Modifier" }}
            </div>

            <div class="align-self-center mb-2">
              <div class="dropdown-curve-container">
                <label
                  :class="selectedModifierCategory.length > 0 ? 'shift-up' : ''"
                  style="font-weight: 600"
                  >{{ "Modifier Category" }}</label
                >
                <multiselect
                  :options="modifierCatergories"
                  v-model="selectedModifierCategory"
                  :searchable="true"
                  :multiple="true"
                  label="category_name"
                  track-by="category_id"
                  @input="onSelectModifierCategories($event, 'select')"
                  @remove="onSelectModifierCategories($event, 'remove')"
                ></multiselect>
                <p
                  v-if="submitted && selectedModifierCategory.length == 0"
                  class="error_message"
                >
                  Please Select Categories.
                </p>
              </div>
            </div>
          </div>

          <div class="row mb-2 ">
            <div
              class="row sec-1 m-2"
              v-for="(singleCinema, CinemaIndex) in CinemaPriceSettings"
              :key="CinemaIndex"
            >
              <div class="col-11">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <!-- SELECT CINEMA -->
                      <div class="col-lg-12 col-xl-3 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              CinemaPriceSettings[CinemaIndex].cinema_id &&
                              String(CinemaPriceSettings[CinemaIndex].cinema_id)
                                .length > 0
                                ? 'shift-up'
                                : ''
                            "
                            style="font-weight: 600"
                            >{{ $tc("cinema", 1) }}</label
                          >
                          <multiselect
                            :options="cinemaListFiltered"
                            v-model="singleCinema.selectedCinemas"
                            :searchable="true"
                            label="cine_name"
                            track-by="cine_id"
                            placeholder=""
                            @input="onDropdownChange($event, CinemaIndex)"
                            :allowEmpty="false"
                            :showLabels="false"
                            :disabled="isRoleID"
                          ></multiselect>
                          <p class="error_message">
                            <span
                              v-if="
                                submitted &&
                                  singleCinema.selectedCinema.length == 0
                              "
                            >
                              Please Select Cinema.
                            </span>
                          </p>
                        </div>
                      </div>

                      <!-- SELECT RECIPE -->
                      <div class="col-lg-4 col-xl-2 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="dropdown-curve-container overFlowHide">
                            <label
                              :class="
                                singleCinema.selected_recipe_name
                                  ? 'shift-up'
                                  : ''
                              "
                            >
                              {{ $t("recipeoptional") }}
                            </label>
                            <multiselect
                              v-model="singleCinema.selected_recipe_name"
                              @remove="
                                onRemoveFnbItem($event, CinemaIndex);
                                fnb_item.recipe_id = null;
                                singleCinema.recipe_label = '';
                              "
                              @select="
                                onSelectFnbItem($event, CinemaIndex);
                                fnb_item.recipe_id = $event.recipe_id;
                                singleCinema.recipe_label = $event.recipe_name;
                              "
                              :placeholder="
                                singleCinema.recipe_label &&
                                singleCinema.recipe_label.length > 0
                                  ? singleCinema.recipe_label
                                  : 'Recipe Optional'
                              "
                              :options="recipes"
                              label="recipe_name"
                              track-by="recipe_id"
                              :value="singleCinema.recipe_name"
                              :multiple="false"
                              :showLabels="true"
                              select-label="Select"
                              deselect-label="Remove"
                              name="selectrecipe"
                              id="selectrecipe"
                              v-b-tooltip.hover
                              :title="$t('fnbitems_tooltip')"
                            />
                          </div>
                        </div>
                        <p class="error_message"></p>
                      </div>

                      <!-- ITEM COST PRICE -->
                      <div class="col-lg-4 col-xl-2 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="."
                              type="number"
                              style="text-align: right"
                              v-model="singleCinema.itemcost_price.costprice"
                              name="costprice"
                              id="costprice"
                            />
                            <label>{{ $t("itemcostprice") }}</label>
                          </div>
                          <!--Tooltip :title="$t('itemcostprice_costPrice')" /-->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('costprice')">{{
                            errors.first("costprice")
                          }}</span>
                        </p>
                      </div>

                      <!-- FNB PRICE -->
                      <div class="col-lg-3 col-xl-2 align-self-center mb-3">
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="."
                              style="text-align: right"
                              v-model="singleCinema.ratecard.frc_amount"
                              v-on:keyup="
                                onChangeRatecardAmount($event, CinemaIndex)
                              "
                              type="number"
                              name="cardamount"
                              id="cardamount"
                              v-validate="{
                                required: 'required',
                                regex: '[0-9]|[0-9]*\\.[0-9]*$',
                              }"
                            />
                            <label>{{ $t("amount") }}</label>
                          </div>
                          <!--Tooltip :title="$t('tooltip')" /-->
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('cardamount')">
                            {{ "Enter Valid Amount" }}
                          </span>
                        </p>
                      </div>

                      <!-- CHARGE SETTING NAME -->
                      <div
                        v-if="singleCinema.cinemaFlag && false"
                        class="col-lg-4 col-xl-3 align-self-center mb-3"
                      >
                        <div
                          class="d-flex align-items-center"
                          v-if="
                            singleCinema.ratecard.frc_pas_setting_name &&
                              singleCinema.ratecard.frc_pas_setting_name
                                .length > 0
                          "
                        >
                          <div class="input-material">
                            <input
                              type="text"
                              :value="
                                singleCinema.ratecard.frc_pas_setting_name
                              "
                              disabled="disabled"
                            />
                            <label class="mb-0 fs-12" style="color: black">{{
                              $t("Charge Setting")
                            }}</label>
                          </div>
                          <!--Tooltip :title="$t('tooltip')" /-->
                        </div>
                        <p class="error_message"></p>
                      </div>

                      <div v-else class="col-lg-4 col-xl-3 align-self-center">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              CinemaPriceSettings[CinemaIndex]
                                .selectedChargeSettingName &&
                              String(
                                CinemaPriceSettings[CinemaIndex]
                                  .selectedChargeSettingName
                              ).length > 0
                                ? 'shift-up'
                                : ''
                            "
                          ></label>
                          <multiselect
                            :options="singleCinema.pas_setting_name_list"
                            :searchable="true"
                            :placeholder="
                              singleCinema.selectedChargeSettingName.length > 0
                                ? singleCinema.selectedChargeSettingName
                                : 'Charge'
                            "
                            label="pas_charge_setting_name"
                            track-by="pas_id"
                            @select="
                              onChangeSettingName($event, $event, CinemaIndex)
                            "
                            :allowEmpty="false"
                            :showLabels="false"
                          ></multiselect>
                          <p class="error_message">
                            <span
                              v-if="
                                submitted &&
                                  singleCinema.selectedChargeSettingName
                                    .length == 0
                              "
                            >
                              Please Select Charge Setting Name.
                            </span>
                          </p>
                        </div>
                      </div>

                      <div class="col-12">
                        <div
                          class="combo-box row"
                          v-for="(category,
                          categoryIndex) in singleCinema.modifier_pack"
                          :key="categoryIndex"
                          v-if="singleCinema.modifier_pack.length > 0"
                        >
                          <div class="col-md-2 col-sm-6">
                            <div class="d-flex align-items-center">
                              <div class="input-material">
                                <input
                                  type="text"
                                  disabled
                                  style="text-align: right"
                                  v-model="category.category_name"
                                  name="category_name"
                                  id="category_name"
                                />
                                <label>{{ "Category" }}</label>
                              </div>
                            </div>
                            <div class="checkbox-box mt-2">
                              <div class="d-flex align-items-center">
                                <b-form-checkbox
                                  type="checkbox"
                                  :name="`non_mandatory_${categoryIndex}`"
                                  :id="`non_mandatory_${categoryIndex}`"
                                  class="j-checkbox"
                                  style="padding-bottom: 0px"
                                  v-model="category.non_mandatory_modifier"
                                  unchecked-value="N"
                                  value="Y"
                                >
                                </b-form-checkbox>
                                <label
                                  class="mb-0 mr-3"
                                  :for="`non_mandatory_${categoryIndex}`"
                                  style="white-space: nowrap"
                                  >{{ $t("Non Mandatory") }}</label
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3 col-sm-6">
                            <div class="dropdown-curve-container">
                              <label
                                :class="'shift-up'"
                                style="font-weight: 600"
                                >{{ "Default Item" }}</label
                              >
                              <multiselect
                                :options="
                                  getModifierCategoryItems(
                                    singleCinema,
                                    category,
                                    null
                                  )
                                "
                                v-model="category.default_item"
                                @select="
                                  onSelectDefaultModifierItem(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'select'
                                  )
                                "
                                @remove="
                                  onSelectDefaultModifierItem(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'remove'
                                  )
                                "
                                :searchable="true"
                                :multiple="false"
                                label="rm_name"
                                track-by="rm_id"
                                :customLabel="customLabelRm"
                                :ref="
                                  `rm_name_CINE${CinemaIndex}_CAT${categoryIndex}`
                                "
                              >
                                <template slot="option" slot-scope="props">
                                  <span v-if="props.option.alt_rm_name">{{
                                    props.option.alt_rm_name
                                  }}</span>
                                  <span v-if="props.option.alt_rm_name"
                                    >- ({{ props.option.rm_name }})</span
                                  >
                                  <span v-else>{{ props.option.rm_name }}</span>
                                </template>
                                <template slot="tag" slot-scope="props">
                                  <span class="multiselect__tag">
                                    <span v-if="props.option.alt_rm_name">{{
                                      props.option.alt_rm_name
                                    }}</span>
                                    <span v-else>{{
                                      props.option.rm_name
                                    }}</span>
                                  </span>
                                </template>
                              </multiselect>
                              <p class="error_message">
                                <span
                                  v-if="
                                    getModifierCategoryItems(
                                      singleCinema,
                                      category,
                                      null
                                    ).length == 0
                                  "
                                  >No Items For Selected Category</span
                                >
                                <span
                                  v-else-if="
                                    !category.default_item_id && submitted
                                  "
                                  >Please Select Item</span
                                >
                              </p>
                            </div>
                          </div>
                          <div class="col-md-1 col-sm-2">
                            <div class="d-flex align-items-center">
                              <div class="input-material">
                                <input
                                  type="number"
                                  style="text-align: right"
                                  v-model="category.quantity"
                                  name="item_qty"
                                  id="item_qty"
                                />
                                <label>{{ "Qty" }}</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-2 col-sm-2">
                            <div class="dropdown-curve-container">
                              <label
                                :class="'shift-up'"
                                style="font-weight: 600"
                                >{{ "UOM" }}</label
                              >
                              <multiselect
                                :options="category['uomList']"
                                v-model="category.selectedUom"
                                @select="
                                  onSelectModifierUOM(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'select'
                                  )
                                "
                                @remove="
                                  onSelectModifierUOM(
                                    $event,
                                    CinemaIndex,
                                    categoryIndex,
                                    'remove'
                                  )
                                "
                                :searchable="true"
                                :multiple="false"
                                :showLabels="false"
                                label="uom_short_form"
                                track-by="uom_id"
                              ></multiselect>
                              <p class="error_message">
                                <span
                                  v-if="
                                    !category['uomList'].length &&
                                      category['default_item_id']
                                  "
                                  >No UOM For Selected Item</span
                                >
                                <span v-else-if="!category.uom_id && submitted"
                                  >Please Select UOM</span
                                >
                              </p>
                            </div>
                          </div>
                          <div class="col-md-4 col-sm-6">
                            <div class="dropdown-curve-container">
                              <label
                                :class="'shift-up'"
                                style="font-weight: 600"
                                >{{ "Alternate Items" }}</label
                              >
                              <multiselect
                                :options="
                                  getModifierCategoryItems(
                                    singleCinema,
                                    category,
                                    'alternate'
                                  )
                                "
                                v-model="category.alternate_items"
                                :searchable="true"
                                :multiple="true"
                                label="rm_name"
                                track-by="rm_id"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :ref="
                                  `alt_rm_name_CINE${CinemaIndex}_CAT${categoryIndex}`
                                "
                              >
                                <template slot="option" slot-scope="props">
                                  <span v-if="props.option.alt_rm_name">{{
                                    props.option.alt_rm_name
                                  }}</span>
                                  <span v-else>{{ props.option.rm_name }}</span>
                                  <span
                                    v-if="
                                      props.option.hasOwnProperty(
                                        '$isDisabled'
                                      ) && props.option['$isDisabled']
                                    "
                                    class="text-truncate"
                                    style="
                                      font-size: 11px !important;
                                      color: red;
                                    "
                                    >{{ "UOM Not Supported" }}
                                  </span>
                                </template>
                                <template slot="tag" slot-scope="props">
                                  <span class="multiselect__tag">
                                    <span v-if="props.option.alt_rm_name">{{
                                      props.option.alt_rm_name
                                    }}</span>
                                    <span v-else>{{
                                      props.option.rm_name
                                    }}</span>
                                  </span>
                                </template>
                              </multiselect>
                              <p class="error_message"></p>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="singleCinema.modifier_pack.length == 0"
                          class="noCategory"
                        >
                          <span>Please Select Modifier Category</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div
                    class="col-lg-12 col-xl-1 d-flex align-items-center combo-inner-title"
                  >
                    {{ "Validity" }}
                  </div> -->

                  <!-- FROM DATE -->
                  <div class="col-lg-4 col-xl-2 align-self-center my-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="singleCinema.ms_fnb_price.fp_from_date"
                            @click="resetFromDate(CinemaIndex)"
                          >
                            ✖
                          </button>
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="singleCinema.ms_fnb_price.fp_from_date"
                            name="fdate1"
                            id="fdate1"
                            typeable
                            v-validate="'required'"
                            v-b-tooltip.hover
                            :title="$t('fnbpricing_fromdate')"
                          ></Datepicker>
                          <label
                            :class="
                              typeof singleCinema.ms_fnb_price.fp_from_date ===
                              'object'
                                ? 'active'
                                : ''
                            "
                            >From</label
                          >
                        </div>
                      </div>
                      <!--Tooltip :title="$t('fnbpricing_fromdate')" /-->
                    </div>
                    <p
                      v-if="submitted && errors.has('fdate1')"
                      class="error_message"
                    >
                      {{ errors.first("fdate1") }}
                    </p>
                  </div>

                  <!-- TO DATE -->
                  <div class="col-lg-4 col-xl-2 align-self-center my-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="singleCinema.ms_fnb_price.fp_to_date"
                            @click="resetToDate(CinemaIndex)"
                          >
                            ✖
                          </button>
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="singleCinema.ms_fnb_price.fp_to_date"
                            name="tdate1"
                            id="tdate1"
                            typeable
                            v-b-tooltip.hover
                            :title="$t('fnbpricing_todate')"
                          ></Datepicker>
                          <label
                            :class="
                              typeof singleCinema.ms_fnb_price.fp_to_date ===
                              'object'
                                ? 'active'
                                : ''
                            "
                            >To (Optional)</label
                          >
                        </div>
                      </div>
                    </div>
                    <!--p class="text-muted fs-12">({{ $t("optional") }})</p-->
                  </div>

                  <template v-if="showErpColumns">
                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.report_code"
                            name="report_code"
                            id="report_code"
                            v-validate=""
                          />
                          <label>{{ "Report Code" }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.gl_account"
                            name="gl_account"
                            id="gl_account"
                            v-validate=""
                          />
                          <label>{{ "GL Account" }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.gl_desc"
                            name="gl_desc"
                            id="gl_desc"
                            v-validate=""
                          />
                          <label>{{ "GL Desc." }}</label>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- CHARGE IS INCLUSIVE SWITCH -->
                  <div
                    class="col-lg-3 col-xl-2 align-self-center mb-0 mx-0 p-0"
                  >
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        unchecked-value="N"
                        value="Y"
                        v-model="
                          singleCinema.ratecard.frc_is_active_inclusivtax
                        "
                        name="check-button"
                        @change="OnSwitchHandler($event, CinemaIndex)"
                        class="j-checkbox pb-0 mb-0"
                      ></b-form-checkbox>
                      <label class="mb-0 mr-3">{{ $t("inclusivoftax") }}</label>
                    </div>
                  </div>

                  <!-- DAYS -->
                  <div class="col-lg-12 col-xl-12 pl-0 ml-4 mb-2">
                    <div class="row">
                      <div class="mr-1" style="color: black">
                        {{ $t("days") }}:
                      </div>
                      <!--{{ $t("select") }}-->
                      <b-form-checkbox
                        v-for="(weekdaysLoop,
                        weekdaysKey) in singleCinema.weekDays"
                        :key="weekdaysKey"
                        style="margin: 0px 3px; min-width: 100px"
                        class="j-checkbox mb-1"
                        @change="
                          onChangeWeekdays($event, weekdaysKey, CinemaIndex)
                        "
                        v-model="singleCinema.weekDays[weekdaysKey]"
                      >
                        <div class="text-capitalize">{{ weekdaysKey }}</div>
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-1 d-flex"
                :class="
                  CinemaPriceSettings && CinemaPriceSettings.length > 1
                    ? 'border-left'
                    : ''
                "
              >
                <button
                  v-if="CinemaPriceSettings && CinemaPriceSettings.length > 1"
                  @click.prevent.stop="removeCinemaSettings(CinemaIndex)"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-4 position-relative"
          >
            <button
              @click.prevent.stop="addCinemaSetting()"
              class="btn-transparent add-more-button"
              :disabled="isRoleID"
            >
              <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
            </button>
          </div>

          <section class="mb-2 w-100 px-0 customization-section-new">
            <div
              class="section-title mb-2 d-flex justify-content-between section-collapse-box"
              v-b-toggle.customizationBlock
              style="padding: 6px; align-items: center"
            >
              <span class="fs">
                {{ $t("add") }} {{ $t("customization") }}
              </span>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse
              id="customizationBlock"
              class="mt-2"
              v-model="sectionCollapse.customizationBlock"
            >
              <div v-if="customizationMap.length > 0">
                <div class="row  back mx-0 rounded mb-2">
                  <div class="col-11 pl-0">
                    <div class="col-12 pt-3">
                      <div class="row">
                        <div
                          class="col-lg-6 col-xl-4 align-self-center mb-4"
                          v-for="(customizationSetting,
                          index) in customizationMap"
                          :key="index"
                        >
                          <div class="dropdown-curve-container pr-28px">
                            <label
                              :class="
                                customizationSetting.selectedCustomization
                                  ? 'shift-up'
                                  : ''
                              "
                              >{{ $tc("customization", 1) }}</label
                            >
                            <multiselect
                              :options="customizations"
                              v-model="
                                customizationSetting.selectedCustomization
                              "
                              :searchable="true"
                              label="item_name"
                              track-by="item_id"
                              placeholder="Customization"
                              @select="onSelectCustomisation($event, index)"
                              @remove="onRemoveCustomisation($event, index)"
                              :allowEmpty="true"
                              :showLabels="false"
                            ></multiselect>
                            <p
                              v-if="
                                submitted &&
                                  !customizationSetting.selectedCustomization
                              "
                              class="error_message"
                            >
                              Please Customization.
                            </p>
                          </div>
                        </div>

                        <!-- <div class="col-lg-3 col-xl-4 align-self-center">
                        <div class="d-flex align-items-center mb-4">
                          <span>{{ $t("compulosry") }}</span>
                          <b-form-checkbox
                            class="ml-3"
                            v-model="customizationSetting.is_compulsory"
                            unchecked-value="N"
                            value="Y"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div> -->
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-1 d-flex align-items-center justify-content-center border-left"
                  >
                    <button
                      v-if="index === 0 && false"
                      @click.prevent.stop="addCustomizationSetting($event)"
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                    <button
                      @click.prevent.stop="
                        removeCustomizationSetting(
                          $event,
                          customizationMap.length - 1
                        )
                      "
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row w-100 pl-5">
                  <p class="mx-auto text-muted mb-1">Add Customization</p>
                </div>
              </div>
              <div
                class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
              >
                <button
                  @click.prevent.stop="addCustomizationSetting($event)"
                  class="btn-transparent add-more-button"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </b-collapse>
          </section>
        </section>

        <section v-else class="col-12 normal-fnb-item px-0">
          <div class="section-title mb-2 mt-3">
            {{ $tc("price", 1) }} {{ $tc("details", 2) }}
          </div>
          <div class="col-md-12 mb-2 ">
            <div
              class="row sec-1 mt-2 mx-1"
              v-for="(singleCinema, CinemaIndex) in CinemaPriceSettings"
              :key="CinemaIndex"
            >
              <div class="col-11">
                <div class="row">
                  <div class="col-md-12"></div>
                  <!-- SELECT CINEMA -->
                  <div class="col-lg-3 col-xl-3 align-self-center mb-3">
                    <div class="dropdown-curve-container pr-28px">
                      <!-- <label
                  :class="singleCinema.selectedCinema.length > 0 ? 'shift-up' : '' "
                >{{ $tc('cinema', 1) }}</label>-->
                      <multiselect
                        :options="cinemaListFiltered"
                        v-model="singleCinema.selectedCinemas"
                        :searchable="true"
                        label="cine_name"
                        track-by="cine_id"
                        placeholder="Cinema"
                        @input="onDropdownChange($event, CinemaIndex)"
                        :allowEmpty="false"
                        :showLabels="false"
                        :disabled="
                          allowedUpdateRoles.includes(role_id)
                            ? false
                            : singleCinema.cinemaFlag
                        "
                      ></multiselect>
                      <!-- <b-dropdown
                  :disabled="isRoleID"
                  :text="singleCinema.selectedCinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(dropdownItem,dropdownIndex) in cinemaList"
                    :key="dropdownIndex"
                    href="#"
                    @click="onDropdownChange($event, dropdownItem,CinemaIndex)"
                  >{{ dropdownItem.cine_name }}</b-dropdown-item>
                </b-dropdown>-->
                      <p
                        v-if="
                          submitted && singleCinema.selectedCinema.length == 0
                        "
                        class="error_message"
                      >
                        Please Select Cinema.
                      </p>
                    </div>
                  </div>

                  <!-- SELECT RECIPE -->

                  <div class="col-lg-4 col-xl-3 align-self-center mb-3">
                    <div class="d-flex align-items-center">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            singleCinema.selected_recipe_name ? 'shift-up' : ''
                          "
                        >
                          {{ $t("recipeoptional") }}
                        </label>
                        <multiselect
                          v-model="singleCinema.selected_recipe_name"
                          @remove="
                            onRemoveFnbItem($event, CinemaIndex);
                            fnb_item.recipe_id = null;
                            singleCinema.recipe_label = '';
                          "
                          @select="
                            onSelectFnbItem($event, CinemaIndex);
                            fnb_item.recipe_id = $event.recipe_id;
                            singleCinema.recipe_label = $event.recipe_name;
                          "
                          :placeholder="
                            singleCinema.recipe_label &&
                            singleCinema.recipe_label.length > 0
                              ? singleCinema.recipe_label
                              : 'Recipe Optional'
                          "
                          :options="recipes"
                          label="recipe_name"
                          track-by="recipe_id"
                          :value="singleCinema.recipe_name"
                          :multiple="false"
                          :showLabels="true"
                          select-label="Select"
                          deselect-label="Remove"
                          name="selectrecipe"
                          id="selectrecipe"
                          v-b-tooltip.hover
                          :title="$t('fnbitems_tooltip')"
                        />
                      </div>
                      <!-- <Tooltip :title="`Movie Language`" /> -->
                    </div>
                    <p class="error_message d-none"></p>
                  </div>

                  <!-- ITEM COST PRICE -->
                  <div class="col-lg-3 col-xl-2 align-self-center mb-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          type="number"
                          style="text-align: right"
                          v-model="singleCinema.itemcost_price.costprice"
                          name="costprice"
                          id="costprice"
                          v-validate="'required|decimal'"
                          :disabled="
                            allowedUpdateRoles.includes(role_id)
                              ? false
                              : singleCinema.cinemaFlag
                          "
                        />
                        <label>{{ $t("Cost price") }}</label>
                      </div>
                      <!---Tooltip :title="$t('itemcostprice_costPrice')" /-->
                    </div>
                    <p
                      v-if="submitted && errors.has('costprice')"
                      class="error_message"
                    >
                      {{ errors.first("costprice") }}
                    </p>
                  </div>

                  <!-- FNB PRICE -->
                  <div class="col-lg-3 col-xl-2 align-self-center mb-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <input
                          placeholder="."
                          v-model="singleCinema.ratecard.frc_amount"
                          v-on:keyup="
                            onChangeRatecardAmount($event, CinemaIndex)
                          "
                          type="number"
                          style="text-align: right"
                          name="cardamount"
                          id="cardamount"
                          v-validate="{
                            required: 'required',
                            regex: '[0-9]|[0-9]*\\.[0-9]*$',
                          }"
                          :disabled="
                            allowedUpdateRoles.includes(role_id)
                              ? false
                              : singleCinema.cinemaFlag
                          "
                        />
                        <label>{{ $t("amount") }}</label>
                      </div>
                      <!--Tooltip :title="$t('tooltip')" /-->
                    </div>
                    <p
                      v-if="submitted && errors.has('cardamount')"
                      class="error_message"
                    >
                      {{ errors.first("cardamount") }}
                    </p>
                  </div>

                  <!-- CHARGE IS INCLUSIVE SWITCH -->
                  <div class="col-lg-3 col-xl-2 align-self-center mb-3">
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        unchecked-value="N"
                        value="Y"
                        v-model="
                          singleCinema.ratecard.frc_is_active_inclusivtax
                        "
                        name="check-button"
                        @change="OnSwitchHandler($event, CinemaIndex)"
                        class="j-checkbox"
                        style="padding-bottom: 0px"
                        :disabled="
                          allowedUpdateRoles.includes(role_id)
                            ? false
                            : singleCinema.cinemaFlag
                        "
                      ></b-form-checkbox>
                      <label class="mb-0 mr-3">{{ $t("inclusivoftax") }}</label>
                    </div>
                  </div>

                  <!-- FROM DATE -->
                  <div class="col-lg-3 col-xl-3 align-self-center mb-3">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="singleCinema.ms_fnb_price.fp_from_date"
                            @click="resetFromDate(CinemaIndex)"
                            style="right: 0"
                          >
                            ✖
                          </button>
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="singleCinema.ms_fnb_price.fp_from_date"
                            name="fdate1"
                            id="fdate1"
                            typeable
                            v-validate="'required'"
                            :disabled="
                              allowedUpdateRoles.includes(role_id)
                                ? false
                                : singleCinema.cinemaFlag
                            "
                            v-b-tooltip.hover
                            :title="$t('fnbpricing_fromdate')"
                          ></Datepicker>
                          <label
                            :class="
                              typeof singleCinema.ms_fnb_price.fp_from_date ===
                              'object'
                                ? 'active'
                                : ''
                            "
                            >From Date</label
                          >
                        </div>
                      </div>
                      <!--Tooltip :title="$t('fnbpricing_fromdate')" /-->
                    </div>
                    <p
                      v-if="submitted && errors.has('fdate1')"
                      class="error_message"
                    >
                      {{ errors.first("fdate1") }}
                    </p>
                  </div>

                  <!-- TO DATE -->
                  <div
                    class="col-lg-3 col-xl-3 align-self-center mb-3"
                    style=""
                  >
                    <!--p class="text-muted fs-12" style="margin-bottom:0px;color:black;">({{ $t("optional") }})</p-->
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="singleCinema.ms_fnb_price.fp_to_date"
                            @click="resetToDate(CinemaIndex)"
                          >
                            ✖
                          </button>
                          <Datepicker
                            :monday-first="true"
                            ref="programaticOpen"
                            v-model="singleCinema.ms_fnb_price.fp_to_date"
                            name="tdate1"
                            id="tdate1"
                            typeable
                            :disabled="
                              allowedUpdateRoles.includes(role_id)
                                ? false
                                : singleCinema.cinemaFlag
                            "
                            v-b-tooltip.hover
                            :title="$t('fnbpricing_todate')"
                          ></Datepicker>
                          <label
                            :class="
                              typeof singleCinema.ms_fnb_price.fp_to_date ===
                              'object'
                                ? 'active'
                                : ''
                            "
                            >To Date (Optional)</label
                          >
                        </div>
                      </div>
                      <!--Tooltip :title="$t('fnbpricing_todate')" /-->
                    </div>
                  </div>

                  <!----Charge Setting---->
                  <div
                    v-if="singleCinema.cinemaFlag && false"
                    class="col-lg-3 col-xl-3 align-self-center mb-3"
                  >
                    <div
                      class="d-flex align-items-center"
                      v-if="
                        singleCinema.ratecard.frc_pas_setting_name &&
                          singleCinema.ratecard.frc_pas_setting_name.length > 0
                      "
                    >
                      <div class="input-material">
                        <input
                          type="text"
                          :value="singleCinema.ratecard.frc_pas_setting_name"
                          disabled="disabled"
                        />
                        <label class="mb-0 fs-12" style="color: black">{{
                          $t("Charge Setting")
                        }}</label>
                      </div>
                      <!--Tooltip :title="$t('tooltip')" /-->
                    </div>
                  </div>

                  <!-- CHARGE SETTING NAME -->
                  <div v-else class="col-lg-3 col-xl-3 align-self-center mb-3">
                    <div class="dropdown-curve-container">
                      <!-- <label
                  :class="singleCinema.selectedChargeSettingName.length > 0 ? 'shift-up' : '' "
                >{{ $tc('chargesettingname', 1) }}</label>-->
                      <!-- <b-dropdown
                  :text="singleCinema.selectedChargeSettingName"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(dropdownItem,dropdownIndex) in singleCinema.pas_setting_name_list"
                    :key="dropdownIndex"
                    href="#"
                    @click="onChangeSettingName($event, dropdownItem,CinemaIndex)"
                  >{{ dropdownItem.pas_charge_setting_name }}</b-dropdown-item>
                </b-dropdown>-->
                      <multiselect
                        :options="singleCinema.pas_setting_name_list"
                        :searchable="true"
                        :placeholder="
                          singleCinema.selectedChargeSettingName.length > 0
                            ? singleCinema.selectedChargeSettingName
                            : 'Charge Setting'
                        "
                        label="pas_charge_setting_name"
                        track-by="pas_id"
                        @select="
                          onChangeSettingName($event, $event, CinemaIndex)
                        "
                        :allowEmpty="false"
                        :showLabels="false"
                      ></multiselect>
                      <p
                        v-if="
                          submitted &&
                            singleCinema.selectedChargeSettingName.length == 0
                        "
                        class="error_message"
                      >
                        Please Select Charge Setting Name.
                      </p>
                    </div>
                  </div>

                  <template v-if="showErpColumns">
                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.report_code"
                            name="report_code"
                            id="report_code"
                            v-validate=""
                          />
                          <label>{{ "Report Code" }}</label>
                        </div>
                      </div>
                      <p class="error_message"></p>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.gl_account"
                            name="gl_account"
                            id="gl_account"
                            v-validate=""
                          />
                          <label>{{ "GL Account" }}</label>
                        </div>
                      </div>
                      <p class="error_message"></p>
                    </div>

                    <div class="col-lg-2 col-xl-2 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            style="text-align: right"
                            placeholder="."
                            type="text"
                            v-model="singleCinema.gl_desc"
                            name="gl_desc"
                            id="gl_desc"
                            v-validate=""
                          />
                          <label>{{ "GL Desc." }}</label>
                        </div>
                      </div>
                      <p class="error_message"></p>
                    </div>
                  </template>

                  <!-- DAYS -->
                  <div class="row ml-4 mb-3">
                    <div class="col-lg-12 col-xl-12 pl-0">
                      <div class="row">
                        <div class="mr-1" style="color: black">
                          {{ $t("days") }}:
                        </div>
                        <!--{{ $t("select") }}-->
                        <b-form-checkbox
                          :disabled="
                            allowedUpdateRoles.includes(role_id)
                              ? false
                              : singleCinema.cinemaFlag
                          "
                          v-for="(weekdaysLoop,
                          weekdaysKey) in singleCinema.weekDays"
                          :key="weekdaysKey"
                          style="margin: 0px 3px; min-width: 100px"
                          class="j-checkbox"
                          @change="
                            onChangeWeekdays($event, weekdaysKey, CinemaIndex)
                          "
                          v-model="singleCinema.weekDays[weekdaysKey]"
                        >
                          <div class="text-capitalize">{{ weekdaysKey }}</div>
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>

                  <!-- CHARGE SETTINGS -->
                  <div class="col-md-12 col-xl-12 col-lg-12">
                    <!---div>
                <div class="font-weight-bold ">
                  {{ $t("add") }} {{ $tc("charge", 2) }}
                </div>
              </div--->

                    <div class="col-12">
                      <div class="row">
                        <!-- IMAGE DIMENSION -->
                        <table
                          class="col-xl-8"
                          v-if="
                            singleCinema &&
                              singleCinema.cinemaChargesList.length > 0
                          "
                        >
                          <tr
                            v-for="(cinemaCharge,
                            cinemaChargesListIndex) in singleCinema.cinemaChargesList"
                            :key="cinemaChargesListIndex"
                            class="main_border_edit"
                          >
                            <td
                              style="
                                padding: 4px 10px;
                                color: black;
                                font-weight: bold;
                              "
                            >
                              {{ cinemaCharge.ct_name }}
                            </td>
                            <td
                              style="
                                padding: 4px 10px;
                                color: black;
                                font-weight: bold;
                                text-align: right;
                              "
                            >
                              {{ cinemaCharge.pas_charge_value
                              }}{{
                                cinemaCharge.pas_is_percentage == "Y" ? "%" : ""
                              }}
                            </td>
                            <td
                              style="
                                padding: 4px 10px;
                                color: black;
                                font-weight: bold;
                                text-align: right;
                              "
                            >
                              {{
                                parseFloat(cinemaCharge.cinemacharges).toFixed(
                                  MIN_FRACTION_DIGITS
                                )
                              }}
                            </td>
                          </tr>
                          <tr class="main_border_edit">
                            <td style="padding: 4px 10px">
                              <span class="font-weight-bold">Net Amount:</span>
                              <span style="color: black; font-weight: bold">
                                {{ currencyData.curr_code }}
                                {{
                                  singleCinema.ratecard.frc_net_amount.toFixed(
                                    2
                                  )
                                }}
                              </span>
                            </td>

                            <td style="padding: 4px 10px">
                              <span class="font-weight-bold">Gross Total:</span>
                              <span style="color: black; font-weight: bold"
                                >{{ currencyData.curr_code }}
                                {{
                                  singleCinema.ratecard.frc_total_amount.toFixed(
                                    2
                                  )
                                }}</span
                              >
                            </td>

                            <td style="padding: 4px 10px">
                              <span class="font-weight-bold">Food Cost %:</span>
                              <span
                                v-if="singleCinema.ratecard.frc_total_amount"
                                style="color: black; font-weight: bold"
                                >{{
                                  +parseFloat(
                                    (
                                      singleCinema.itemcost_price.costprice /
                                      singleCinema.ratecard.frc_total_amount
                                    ).toFixed(4) * 100
                                  ).toFixed(4)
                                }}%</span
                              >
                            </td>
                          </tr>
                        </table>

                        <div class="col-md-4" v-if="false">
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                              <label style="padding: 1rem">{{
                                cinemaCharge.ct_name
                              }}</label>
                            </div>
                          </div>
                          <!-- <p class="error_msg">Invalid Entry</p> -->
                        </div>
                        <div class="col-md-5" v-if="false">
                          <div class="row">
                            <div class="col-md-5">
                              <div
                                class="d-flex justify-content-center align-items-center p-3"
                              >
                                <label
                                  >{{ cinemaCharge.pas_charge_value
                                  }}{{
                                    cinemaCharge.pas_is_percentage == "Y"
                                      ? "%"
                                      : ""
                                  }}</label
                                >
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div
                                class="d-flex justify-content-center align-items-center p-3"
                              >
                                <label>{{
                                  cinemaCharge.cinemacharges.toFixed(4)
                                }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12" v-if="false">
                      <div class="text-right">
                        <div>
                          <span class="font-weight-bold">Net Amount:</span>
                          <span
                            >{{ currencyData.curr_code }}
                            {{
                              parseFloat(
                                singleCinema.ratecard.frc_net_amount
                              ).toFixed(MIN_FRACTION_DIGITS)
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="false">
                      <div class="text-right">
                        <div>
                          <span class="font-weight-bold">Gross Total:</span>
                          <span
                            >{{ currencyData.curr_code }}
                            {{
                              singleCinema.ratecard.frc_total_amount.toFixed(
                                MIN_FRACTION_DIGITS
                              )
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="false">
                      <div class="text-right">
                        <div>
                          <span class="font-weight-bold">Food Cost %:</span>
                          <span v-if="singleCinema.ratecard.frc_total_amount"
                            >{{
                              +parseFloat(
                                (
                                  singleCinema.itemcost_price.costprice /
                                  singleCinema.ratecard.frc_total_amount
                                ).toFixed(4) * 100
                              ).toFixed(4)
                            }}%</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!---Add accordian--->

                  <!-- CHARGE SETTINGS -->
                  <div class="col-md-12" v-if="false">
                    <div>
                      <div class="font-weight-bold mb-2">
                        {{ $t("add") }} {{ $tc("charge", 2) }}
                      </div>
                    </div>

                    <div
                      class="col-12"
                      v-for="(cinemaCharge,
                      cinemaChargesListIndex) in singleCinema.cinemaChargesList"
                      :key="cinemaChargesListIndex"
                    >
                      <div class="row">
                        <!-- IMAGE DIMENSION -->
                        <div class="col-md-5 mb-4">
                          <div class="d-flex align-items-center">
                            <div class="input-material">
                              <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                              <label>{{ cinemaCharge.ct_name }}</label>
                            </div>
                          </div>
                          <!-- <p class="error_msg">Invalid Entry</p> -->
                        </div>
                        <div class="col-md-7">
                          <div class="row">
                            <div class="col-md-5">
                              <div
                                class="d-flex justify-content-center align-items-center p-3"
                              >
                                <label
                                  >{{ cinemaCharge.pas_charge_value
                                  }}{{
                                    cinemaCharge.pas_is_percentage == "Y"
                                      ? "%"
                                      : ""
                                  }}</label
                                >
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div
                                class="d-flex justify-content-center align-items-center p-3"
                              >
                                <label>{{
                                  cinemaCharge.cinemacharges.toFixed(4)
                                }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="text-right">
                        <div>
                          <span class="font-weight-bold">Net Amount:</span>
                          <span
                            >{{ currencyData.curr_code }}
                            {{
                              singleCinema.ratecard.frc_net_amount.toFixed(
                                MIN_FRACTION_DIGITS
                              )
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="text-right">
                        <div>
                          <span class="font-weight-bold">Gross Total:</span>
                          <span
                            >{{ currencyData.curr_code }}
                            {{
                              singleCinema.ratecard.frc_total_amount.toFixed(
                                MIN_FRACTION_DIGITS
                              )
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="text-right">
                        <div>
                          <span class="font-weight-bold">Food Cost %:</span>
                          <span v-if="singleCinema.ratecard.frc_total_amount"
                            >{{
                              +parseFloat(
                                (
                                  singleCinema.itemcost_price.costprice /
                                  singleCinema.ratecard.frc_total_amount
                                ).toFixed(4) * 100
                              ).toFixed(4)
                            }}%</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-1 d-flex"
                :class="
                  CinemaPriceSettings && CinemaPriceSettings.length > 1
                    ? 'border-left'
                    : ''
                "
              >
                <button
                  v-if="CinemaPriceSettings && CinemaPriceSettings.length > 1"
                  @click.prevent.stop="removeCinemaSettings(CinemaIndex)"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>

            <div
              class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-4 position-relative"
            >
              <button
                @click.prevent.stop="addCinemaSetting()"
                class="btn-transparent add-more-button"
                :disabled="isRoleID"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
            </div>
          </div>

          <div class="col-12 mb-2 px-0">
            <!--label>Alternate FNB Items</label--->
            <multiselect
              v-model="selected_alternate_items"
              track-by="item_code"
              label="item_name"
              :options="alternate_items_list"
              :multiple="true"
              placeholder="Alternate Items"
              :showLabels="false"
              @remove="removeAlternateItem($event)"
            ></multiselect>
          </div>

          <section class="mb-2 w-100 px-0 customization-section-new">
            <div
              class="section-title mb-2 d-flex justify-content-between section-collapse-box"
              v-b-toggle.customizationBlock
              style="padding: 6px; align-items: center"
            >
              <span class="fs">
                {{ $t("add") }} {{ $t("customization") }}
              </span>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse
              id="customizationBlock"
              class="mt-2"
              v-model="sectionCollapse.customizationBlock"
            >
              <div v-if="customizationMap.length > 0">
                <div class="row  back mx-0 rounded mb-2">
                  <div class="col-11 pl-0">
                    <div class="col-12 pt-3">
                      <div class="row">
                        <div
                          class="col-lg-6 col-xl-4 align-self-center mb-4"
                          v-for="(customizationSetting,
                          index) in customizationMap"
                          :key="index"
                        >
                          <div class="dropdown-curve-container pr-28px">
                            <label
                              :class="
                                customizationSetting.selectedCustomization
                                  ? 'shift-up'
                                  : ''
                              "
                              >{{ $tc("customization", 1) }}</label
                            >
                            <multiselect
                              :options="customizations"
                              v-model="
                                customizationSetting.selectedCustomization
                              "
                              :searchable="true"
                              label="item_name"
                              track-by="item_id"
                              placeholder="Customization"
                              @select="onSelectCustomisation($event, index)"
                              @remove="onRemoveCustomisation($event, index)"
                              :allowEmpty="true"
                              :showLabels="false"
                            ></multiselect>
                            <p
                              v-if="
                                submitted &&
                                  !customizationSetting.selectedCustomization
                              "
                              class="error_message"
                            >
                              Please Customization.
                            </p>
                          </div>
                        </div>

                        <!-- <div class="col-lg-3 col-xl-4 align-self-center">
                        <div class="d-flex align-items-center mb-4">
                          <span>{{ $t("compulosry") }}</span>
                          <b-form-checkbox
                            class="ml-3"
                            v-model="customizationSetting.is_compulsory"
                            unchecked-value="N"
                            value="Y"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div> -->
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-1 d-flex align-items-center justify-content-center border-left"
                  >
                    <button
                      v-if="index === 0 && false"
                      @click.prevent.stop="addCustomizationSetting($event)"
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                    <button
                      @click.prevent.stop="
                        removeCustomizationSetting(
                          $event,
                          customizationMap.length - 1
                        )
                      "
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row w-100 pl-5">
                  <p class="mx-auto text-muted mb-1">Add Customization</p>
                </div>
              </div>
              <div
                class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
              >
                <button
                  @click.prevent.stop="addCustomizationSetting($event)"
                  class="btn-transparent add-more-button"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </b-collapse>
          </section>
        </section>

        <div class="col-md-12 text-center mt-4">
          <!-- <button
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>-->
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>

          <button class="btn-blue">
            {{ $t("Save As Draft") }}
          </button>
          <!-- <button
            :disabled="btenable"
            @click.prevent.stop="onResetForm()"
            class="btn-black"
          >{{ $t('reset') }}</button>-->
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/fnb/fnb-items"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>

    <!-- MOVIE POSTER IMAGE MODAL -->
    <b-modal
      size="lg"
      hide-footer
      ref="preview-modal"
      id="selected-image-preview-modal"
      title="FNB Image"
    >
      <img :src="_GetImagePath(fnb_item.item_image_url)" class="img-fluid" />
    </b-modal>

    <b-modal
      size="sm"
      hide-footer
      hide-header
      centered
      no-fade
      ref="manualSelectCategory"
      id="manualSelectCategory"
      title=""
    >
      <div class="text-center fs-16 font-weight-bold">Categories</div>
      <b-list-group style="height: 380px; overflow-x: auto">
        <b-list-group-item
          v-for="(category, categoryIndex) in ms_food_categories"
          :key="categoryIndex"
          @click="onSelectManualCategory(category)"
          >{{ category.fc_category }}</b-list-group-item
        >
      </b-list-group>
    </b-modal>

    <!-- Image Upload Modal -->
    <!-- <b-modal id="imagecropper" hide-header hide-footer>
      <label class="h4 mt-2 mb-4 text-center">Crop Image</label>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :aspect-ratio="197 / 295"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
    </b-modal>-->
    <!-- 129*192 -->
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import PosFnbService from "@/services/PosFnbService";
  import CinemasService from "@/services/CinemasService";
  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  import ImageGallery from "../../ImageGallery/imageGalleryModal";
  import { mapGetters } from "vuex";
  import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
  import MovieService from "@/services/MovieService";
  import _ from "lodash";

  export default {
    components: { VueCropper, ImageGallery },
    data() {
      return {
        AllCinemaChargeSettingsArray: [],
        UomList: [],
        selectedModifierCategory: [],
        modifierCatergories: [],
        comboDetailsLoader: null,
        cinemaLoader: false,
        selectedComboCategory: [],
        selectrecipe: "",
        removed_alternate_items: [],
        selected_alternate_items: [],
        alternate_items_list: [],
        ms_food_categoriesCopy: [],
        searchFoodCategories: "",
        set_width: null,
        set_height: null,
        showModal: false,
        isRoleID: true,
        imgSrc: "",
        cropImg: "",
        filename: "",
        indexofthubmnail: "",
        loader: this.$loading,
        submitted: false,
        errmsg: "",
        cinemaList: [],
        cinemaListCopy: [],
        currencyData: [],
        btenable: false,
        fnb_item: {
          item_id: "",
          item_name: "",
          alternate_lang_item_name: "",
          item_description: "",
          fi_order: null,
          item_age_restriction: "",
          item_code: "",
          fc_id: "",
          recipe_id: "",
          customization_common_id: null,
          is_sundry: "N",
          is_combo: "N",
          has_modifiers: "N",
          is_premier_item: "N",
          is_non_sellable_product: "N",
          ready_to_serve: "N",
          item_is_veg: true,
          item_is_recipe: "",
          item_image_url: "",
          includes_egg: true,
          is_package_item: false,
          item_is_active: true,
          selected_customizations: [],
        },

        customizations: [],
        customizationsCopy: [],
        searchCustomization: "",
        customization_name: "",

        CinemaPriceSettings: [
          {
            selectedCinema: "",
            selectedCinemas: [],
            cinema_id: null,
            recipe_label: "",
            cinemaFlag: false,
            combo_pack: [],
            modifier_pack: [],
            isLoading: false,
            fnb_item_array: [],
            //ITEM COST PRICE
            itemcost_price: {
              itc_id: "",
              cinema_id: "",
              v_id: "",
              item_id: "",
              costprice: "",
              fp_is_active: true,
            },
            report_code: "",
            gl_account: "",
            gl_desc: "",
            //RATE CARD

            selectedCinema: "",
            cinemaList: [],
            currencyData: [],
            ratecard: {
              frc_id: null,
              cinema_id: null,
              frc_name: Math.floor(1000 + Math.random() * 9000),
              frc_amount: 0,
              currency_id: null,
              frc_is_active_inclusivtax: "Y",
              frc_is_active: "N",
              frc_net_amount: 0,
              frc_total_amount: 0,
              curr_code: null,
            },
            selectedChargeSettingName: "",
            pas_setting_name_list: [],
            cinemaChargesList: [],
            //FNB Pricing
            weekDays: {
              AllDays: false,
              monday: false,
              tuesday: false,
              wednesday: false,
              thursday: false,
              friday: false,
              saturday: false,
              sunday: false,
            },
            ms_fnb_price: {
              cinema_id: "",
              item_id: "",
              currency_id: "",
              fnb_rate_card_id: "",
              fp_amount: "",
              fp_total_amount: "",
              fp_from_date: "",
              fp_to_date: "",
              fp_is_active: true,
              fp_sunday: true,
              fp_monday: true,
              fp_tuesday: true,
              fp_wednesday: true,
              fp_thursday: true,
              fp_friday: true,
              fp_saturday: true,
            },
          },
        ],

        ImageLength: "",
        ms_food_categories: [],
        BaseURL: "",
        recipes: [],
        recipe_label: "Select Recipe",
        fc_parent_label: "Select Food Category",
        occupiedCinemas: [],
        role_id: null,
        removedPriceDetails: [],
        Languages: [],
        ContentLanguages: [],
        activeClass: 0,
        FnbItemContent: [],
        tempFnbContentData: [],
        fnbId: "",
        notempty: [false, false, false, false, false, false],
        customizationMap: [],
        sectionCollapse: {
          customizationBlock: false,
        },
        removedCustomizations: [],
        onlyActive: "N",
      };
    },
    created() {
      // this.getMovieContentLangauge();
    },
    beforeMount() {
      this.fnb_item.item_code = this.$route.query.item_code;
      this.onlyActive = this.$route.query.item_is_active;
      let obj = this.secureStore.get("USINFO").cinema_id;
      this.role_id = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
        this.getCinemaList(obj);
      } else {
        this.getCinemaList(obj);
      }
      this.getGlobalOptions();
      this.getAllCinemaChargeSettings();
    },
    computed: {
      showErpColumns() {
        return this.$store.getters.SHOW_ERP_GL_FIELDS == "Y" ? true : false;
      },
      qfx_tax_structure() {
        return this.authorizeClient(CLIENT_NAMES_OBJ.qfx_tax_structure);
      },
      mif_tax_calculation() {
        return this.authorizeClient(CLIENT_NAMES_OBJ.mif_tax_calculation);
      },
      allowedUpdateRoles() {
        let roles = [1, 2];
        if (this.authorizeClient(CLIENT_NAMES_OBJ.empire)) {
          roles.push(50);
        }
        if (this.authorizeClient(CLIENT_NAMES_OBJ.starcinemas)) {
          roles.push(37);
        }
        if (CLIENT_NAME.DESIRASOI == this.CLIENT_SETUP_NAME) {
          console.log("Rasoi True");
          roles.push(36);
        }
        if (this.authorizeClient(CLIENT_NAMES_OBJ.EPIX)) {
          roles.push(3);
        }
        if (this.authorizeClient(CLIENT_NAMES_OBJ.platinum)) {
          roles.push(39);
        }
        return roles;
      },
      fractionDigits() {
        let fracDigit = 3;
        if (this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis_combo)) {
          fracDigit = 2;
        } else {
          fracDigit = 3;
        }
        return fracDigit;
      },
      cinemaListFiltered() {
        let cinemaArray = this.cinemaListCopy;

        cinemaArray = this.cinemaListCopy.filter(
          (x) => !this.CinemaPriceSettings.some((y) => y.cinema_id == x.cine_id)
        );

        return cinemaArray;
      },
      list() {
        return this.cinemaChargesList;
      },

      ...mapGetters(["finalImagePath"]),
    },
    watch: {
      finalImagePath(newval) {
        this.fnb_item.item_image_url = newval;
      },
    },
    async mounted() {
      await this.getFnbItemDetails();
      await this.getAlternateItems();
      // await this.getItemCostPrice();
      // await this.getFnbPricing();
      await this.getRecipeList();
      await this.getFoodCategoiresList();
      // await this.getCustomizationList();
    },
    methods: {
      getAllCinemaChargeSettings() {
        this.AllCinemaChargeSettingsArray = [];
        PosFnbService.GetAllTaxSettings()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records && data.Records.length) {
              this.AllCinemaChargeSettingsArray = data.Records;
            } else {
              console.log("getAllCinemaChargeSettings", data);
            }
          })
          .catch((err) => {
            console.log("Error: getAllCinemaChargeSettings", err);
          });
      },
      onAddManualCategory() {
        this.$bvModal.show("manualSelectCategory");
      },
      onSelectManualCategory(category) {
        this.selectedComboCategory.push(category);
        this.onSelectComboCategories(category, "forceAdd");
        this.$bvModal.hide("manualSelectCategory");
      },
      removeElement: function(element, refId) {
        this.$refs[refId].removeElement(element);
      },
      customLabelRm(e) {
        return `${e.alt_rm_name ? e.alt_rm_name : e.rm_name}`;
      },
      onChangeIsVeg(event) {
        console.log("onChangeIsVeg", event);
        if (!event) {
          this.fnb_item.includes_egg = false;
        }
      },
      getComboCinemaList(cinema_id, cinemaIndex) {
        this.CinemaPriceSettings[cinemaIndex]["isLoading"] = true;
        let payload = {
          category: null,
          cinema_id: cinema_id,
          isCombo: false,
          isEgg: "",
          isVeg: "",
          search: "",
          subCategory: null,
          skipSellableFlag: "Y",
        };

        PosFnbService.GetFnBList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data && data.status && data.Records && data.Records.Records) {
                this.CinemaPriceSettings[
                  cinemaIndex
                ].fnb_item_array = _.cloneDeep(data.Records.Records);
                this.CinemaPriceSettings[cinemaIndex]["isLoading"] = false;
              } else {
                this.CinemaPriceSettings[cinemaIndex].fnb_item_array = [];
                this.CinemaPriceSettings[cinemaIndex]["isLoading"] = false;
              }
            }
          })
          .catch((err) => {
            console.log("Error;", err);
            this.CinemaPriceSettings[cinemaIndex].fnb_item_array = [];
          })
          .finally(() => {
            this.CinemaPriceSettings[cinemaIndex]["isLoading"] = false;
          });
      },
      onClickCombo(event) {
        if (event == "Y") {
          this.fnb_item.recipe_id = null;
          this.fnb_item.is_combo = event;
          this.fnb_item.has_modifiers = "N";
          this.fnb_item.item_is_recipe = "";
          this.fnb_item.selected_alternate_items = [];
          this.fnb_item.selected_customizations = [];
        }
        this.resetCinemaPriceSettings();
      },
      onClickModifier(event) {
        if (event == "Y") {
          this.fnb_item.recipe_id = null;
          this.fnb_item.is_combo = "N";
          this.fnb_item.has_modifiers = "Y";
          this.fnb_item.item_is_recipe = "";
          this.fnb_item.selected_alternate_items = [];
          this.fnb_item.selected_customizations = [];
        }
      },
      getUomList() {
        this.UomList = [];
        let payload = {
          tableName: "ms_unit_of_measurement",
          uom_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.UomList = data.Records;
            }
          })
          .catch((error) => {
            console.log("Error:", error);
          });
      },
      getModifierCategories: function() {
        let payload = {};
        PosFnbService.GetActiveModifiersCategoriesDetails(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.modifierCatergories = data.Records;
            } else {
              console.log("message", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      resetCinemaPriceSettings() {
        let CinemaPriceSettings = [
          {
            selectedCinema: "",
            selectedCinemas: [],
            cinema_id: null,
            recipe_label: "",
            combo_pack: [],
            modifier_pack: [],
            fnb_item_array: [],
            //ITEM COST PRICE
            itemcost_price: {
              cinema_id: "",
              v_id: "",
              item_id: "",
              costprice: "",
              fp_is_active: true,
            },
            report_code: "",
            gl_account: "",
            gl_desc: "",
            //RATE CARD

            selectedCinema: "",
            ratecard: {
              cinema_id: null,
              frc_name: "",
              frc_amount: "",
              currency_id: null,
              frc_is_active_inclusivtax: "Y",
              frc_net_amount: 0,
              frc_total_amount: 0,
            },
            selectedChargeSettingName: "",
            pas_setting_name_list: [],
            cinemaChargesList: [],
            //FNB Pricing
            ms_fnb_price: {
              cinema_id: "",
              item_id: "",
              currency_id: "",
              fnb_rate_card_id: "",
              fp_amount: "",
              fp_total_amount: "",
              fp_from_date: new Date(),
              fp_to_date: "",
              fp_is_active: true,
            },
            weekDays: {
              AllDays: true,
              monday: true,
              tuesday: true,
              wednesday: true,
              thursday: true,
              friday: true,
              saturday: true,
              sunday: true,
            },
          },
        ];
        this.CinemaPriceSettings = _.cloneDeep(CinemaPriceSettings);
      },
      onSelectDefaultItem(event, cinemaIndex, categoryIndex, type) {
        if (type == "select") {
          this.CinemaPriceSettings[cinemaIndex].combo_pack[
            categoryIndex
          ].default_item = event;
          this.CinemaPriceSettings[cinemaIndex].combo_pack[
            categoryIndex
          ].default_item_id = event.item_id;
          this.CinemaPriceSettings[cinemaIndex].combo_pack[
            categoryIndex
          ].default_item_name = event.item_name;
          this.CinemaPriceSettings[cinemaIndex].combo_pack[
            categoryIndex
          ].alternate_items = [];
        } else if (type == "remove") {
          this.CinemaPriceSettings[cinemaIndex].combo_pack[
            categoryIndex
          ].default_item = "";
          this.CinemaPriceSettings[cinemaIndex].combo_pack[
            categoryIndex
          ].default_item_id = null;
          this.CinemaPriceSettings[cinemaIndex].combo_pack[
            categoryIndex
          ].default_item_name = "";
        }
      },
      getCategoryItems(singleCinema, category_id, category, type = null) {
        let fnbArray = [];
        if (
          singleCinema &&
          singleCinema.hasOwnProperty("fnb_item_array") &&
          singleCinema.fnb_item_array.length > 0
        ) {
          fnbArray =
            singleCinema.fnb_item_array.filter(
              (x) =>
                x.fc_id == category_id &&
                x.has_alternate_items == "N" &&
                x.isCustomization == "N" &&
                x.is_combo == "N"
            ) || [];
        }
        if (
          type == "alternate" &&
          category &&
          category.hasOwnProperty("default_item") &&
          category.default_item.hasOwnProperty("item_id")
        ) {
          fnbArray = fnbArray.filter(
            (x) => x.item_id != category.default_item.item_id
          );
        }
        return fnbArray;
      },
      onSelectComboCategories(event, type) {
        console.log("Event", event);
        console.log("Event type", type);

        if (this.selectedComboCategory.length == 0) {
          this.CinemaPriceSettings.forEach((x) => {
            x["combo_pack"] = [];
          });
        } else {
          if (type == "remove") {
            this.CinemaPriceSettings.forEach((x) => {
              let findIndex = x.combo_pack.findIndex(
                (index) => index.category_id == event.fc_id
              );
              if (findIndex > -1) {
                x.combo_pack.splice(findIndex, 1);
              }
            });
          } else if (type == "forceAdd") {
            this.CinemaPriceSettings.forEach((x, index) => {
              let categoryObj = {
                category_id: event.fc_id,
                category_name: event.fc_category,
                alternate_items: [],
                quantity: 1,
                min_quantity: 1,
                max_quantity: 1,
                min_max_setting: "N",
                default_item: "",
                default_item_id: null,
                default_item_name: "",
              };
              x.combo_pack.push(categoryObj);
            });
          } else {
            this.CinemaPriceSettings.forEach((x) => {
              this.selectedComboCategory.forEach((category) => {
                if (
                  !x.combo_pack.some((c) => c.category_id == category.fc_id)
                ) {
                  let categoryObj = {
                    category_id: category.fc_id,
                    category_name: category.fc_category,
                    alternate_items: [],
                    quantity: 1,
                    min_quantity: 1,
                    max_quantity: 1,
                    min_max_setting: "N",
                    default_item: "",
                    default_item_id: null,
                    default_item_name: "",
                  };
                  x.combo_pack.push(categoryObj);
                }
              });
            });
          }
        }
      },
      onSelectDefaultModifierItem(event, cinemaIndex, categoryIndex, type) {
        if (type == "select") {
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].default_item = event;
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].default_item_id = event.rm_id;
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].default_item_name = event.rm_name;
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].alternate_items = [];
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].selectedUom = "";
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].uom_id = null;
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].uomList = this.getFilteredUOM(event["uom_id_threshold"]);
        } else if (type == "remove") {
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].default_item = "";
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].default_item_id = null;
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].default_item_name = "";
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].selectedUom = "";
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].uom_id = null;
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].uomList = [];
        }
      },
      getFilteredUOM(uom_id) {
        let UOMArray = [];
        let checkUOM = [...this.UomList].filter((x) => x.uom_id == uom_id);
        console.log("checkUOM", checkUOM);
        if (checkUOM && checkUOM.length) {
          UOMArray = [...UOMArray, ...checkUOM];
          console.log("UOMArray 1", UOMArray);
          if (
            checkUOM[0].hasOwnProperty("uom_parent_id") &&
            checkUOM[0].uom_parent_id
          ) {
            let tempArr = [...this.UomList].filter(
              (x) => x.uom_id == checkUOM[0].uom_parent_id
            );
            if (tempArr && tempArr.length) {
              UOMArray = [...UOMArray, ...tempArr];
              console.log("UOMArray 2", UOMArray);
            }
          } else {
            let tempArr = [...this.UomList].filter(
              (x) => x.uom_parent_id == checkUOM[0].uom_id
            );
            if (tempArr && tempArr.length) {
              UOMArray = [...UOMArray, ...tempArr];
              console.log("UOMArray 3", UOMArray);
            }
          }
        }
        console.log("UOMArray 4", UOMArray);
        return UOMArray;
      },
      onSelectModifierUOM(event, cinemaIndex, categoryIndex, type) {
        if (type == "select") {
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].selectedUom = event;
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].uom_id = event.uom_id;
        } else if (type == "remove") {
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].selectedUom = "";
          this.CinemaPriceSettings[cinemaIndex].modifier_pack[
            categoryIndex
          ].uom_id = null;
        }
      },
      getModifierCategoryItems(singleCinema, category, type = null) {
        let tempArray = [];
        if (
          singleCinema &&
          category &&
          category.hasOwnProperty("mappedArray") &&
          category.mappedArray.length > 0
        ) {
          tempArray = [...category.mappedArray] || [];
        }
        if (
          type == "alternate" &&
          category &&
          category.hasOwnProperty("default_item") &&
          category.default_item &&
          category.default_item.hasOwnProperty("rm_id")
        ) {
          tempArray = tempArray.filter(
            (x) => x.rm_id != category.default_item.rm_id
          );
        }
        if (
          category.hasOwnProperty("uomList") &&
          category.uomList.length &&
          type == "alternate"
        ) {
          let newTempArr = _.cloneDeep(tempArray);
          newTempArr.map((x) => {
            if (
              !category["uomList"].some(
                (_uom) => _uom["uom_id"] == x.uom_id_threshold
              )
            ) {
              x["$isDisabled"] = true;
            }
          });
          return newTempArr;
        } else {
          return tempArray;
        }
      },
      onSelectModifierCategories(event, type) {
        if (this.selectedModifierCategory.length == 0) {
          this.CinemaPriceSettings.forEach((x) => {
            x["modifier_pack"] = [];
          });
        } else {
          if (type == "remove") {
            this.CinemaPriceSettings.forEach((x) => {
              let findIndex = x.modifier_pack.findIndex(
                (index) => index.category_id == event.category_id
              );
              if (findIndex > -1) {
                x.modifier_pack.splice(findIndex, 1);
              }
            });
          } else {
            console.log(
              "this.selectedModifierCategory",
              this.selectedModifierCategory
            );
            this.CinemaPriceSettings.forEach((x, index) => {
              this.selectedModifierCategory.forEach((category) => {
                if (
                  !x.modifier_pack.some(
                    (c) => c.category_id == category.category_id
                  )
                ) {
                  let categoryObj = {
                    category_id: category.category_id,
                    category_name: category.category_name,
                    alternate_items: [],
                    quantity: 1,
                    uom_id: null,
                    non_mandatory_modifier: "N",
                    selectedUom: "",
                    default_item: "",
                    default_item_id: null,
                    default_item_name: "",
                    mappedArray: category.mappedArray,
                    uomList: [],
                  };
                  x.modifier_pack.push(categoryObj);
                }
              });
            });
          }
        }
      },
      checkWeekDays() {
        this.CinemaPriceSettings.map((z, index) => {
          let temp_arr = [];
          Object.keys(z.weekDays).map((y) => {
            if (y != "AllDays" && z.weekDays[y]) {
              temp_arr.push(z.weekDays[y]);
            }
          });
          console.log(temp_arr, "temp_arr", z);
          if (temp_arr.length >= 7) {
            z.weekDays.AllDays = true;
          } else {
            z.weekDays.AllDays = false;
          }
        });
        return this.CinemaPriceSettings;
      },
      onSelectCustomisation(customization, index) {
        let count = 0;
        this.customizationMap.map((x) => {
          if (x.customization_id == customization.item_id) {
            count++;
          }
        });
        if (count > 0) {
          this.customizationMap[index].selectedCustomization = "";
          this.$forceUpdate();
          return this.$toasted.show("Already selected");
        } else {
          this.customizationMap[index].customization_id = customization.item_id;
        }
      },
      onRemoveCustomisation(customization, index) {
        this.customizationMap[index].customization_id = null;
      },
      addCustomizationSetting() {
        let obj = {
          customization_id: null,
          selectedCustomization: "",
          is_compulsory: "N",
        };
        this.customizationMap.push(obj);
      },
      removeCustomizationSetting(event, index) {
        console.log("removeCustomizationSetting index", index);
        console.log("this.customizationMap", this.customizationMap);
        if (
          this.customizationMap[index].hasOwnProperty("fcm_id") &&
          this.customizationMap[index].fcm_id
        ) {
          this.removedCustomizations.push(this.customizationMap[index].fcm_id);
        }
        this.customizationMap.splice(index, 1);
      },
      getMovieContentLangauge: function(FnbContent) {
        MovieService.GetMovieContentLanguages()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.ContentLanguages.length > 0) {
                // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
                //   "langauge"
                // ]);
                this.ContentLanguages = data.ContentLanguages;
              }
              console.log("this.ContentLanguages", this.ContentLanguages);
            } else {
              // Show Error:
              console.log("data.message :", data.message);
            }
            return;
          })
          .then(() => {
            this.makeLangContainers(FnbContent);
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error On getMovieContentLangauge :", error);
          });
      },
      onChangeItemName(event, type) {
        this.FnbItemContent.map((x) => {
          if (x.langauge.toLowerCase() == "english") {
            if (type == "name") {
              x.item_name = event.target.value;
            } else if (type == "desc") {
              x.item_description = event.target.value;
            }
          }
        });
      },
      makeLangContainers: function(FnbContent) {
        let Obj;
        console.log("FnbContent", FnbContent);
        this.ContentLanguages.map((x, i) => {
          let Array1 = FnbContent.filter((y) => {
            return y.content_lang_id == x.langaugeId;
          });
          if (Array1.length > 0) {
            x["mfc_id"] = Array1[0].mfc_id;
            x["fnb_id"] = Array1[0].fnb_id;
            x["item_name"] = Array1[0].item_lang_name;
            x["item_description"] = Array1[0].item_lang_description;
            if (Array1[0].item_lang_name && Array1[0].item_lang_description) {
              this.notempty[i] = true;
            }
          } else {
            x["fnb_id"] = this.fnbId;
            x["item_name"] = "";
            x["item_description"] = "";
          }
        });
        this.FnbItemContent = this.ContentLanguages;
        console.log("hjhf", this.ContentLanguages);
      },
      onChangeTabHandler: function(event, index) {
        this.activeClass = index;
      },
      resetFromDate(index) {
        this.CinemaPriceSettings[index].ms_fnb_price.fp_from_date = "";
      },
      resetToDate(index) {
        this.CinemaPriceSettings[index].ms_fnb_price.fp_to_date = "";
      },
      clearCustomisation() {
        this.customization_name = "";
      },
      removeAlternateItem(item) {
        this.removed_alternate_items.push(item);
      },
      getAssignedAlternateItems: function() {
        PosFnbService.GetAssignedAlternateItems({
          item_code: this.fnb_item.item_code,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              // this.selected_alternate_items = data.Records;
              let tempArr = [];
              data.Records.forEach((x) => {
                if (!tempArr.some((_temp) => _temp.item_code == x.item_code)) {
                  tempArr.push(x);
                }
              });
              this.selected_alternate_items = [...tempArr];
            } else {
            }
          })
          .catch((error) => {
            console.log("Catch Error on getAssignedAlternateItems :", error);
          });
      },
      getAlternateItems: function() {
        PosFnbService.GetAlternateItems()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.alternate_items_list = data.Records;
              this.alternate_items_list.filter((x, i) => {
                if (this.fnb_item.item_code == x.item_code) {
                  this.alternate_items_list.splice(i, 1);
                }
              });

              this.getAssignedAlternateItems();
            } else {
            }
          })
          .catch((error) => {
            console.log("Catch Error on getAlternateItems :", error);
          });
      },
      onChangeSettingName: function(event, item, index) {
        this.CinemaPriceSettings[index].selectedChargeSettingName =
          item.pas_charge_setting_name;
        this.getCinemaCharges(
          this.CinemaPriceSettings[index].ratecard.cinema_id,
          index
        );
      },
      getCinemaCharges: async function(id, index) {
        this.CinemaPriceSettings[index].cinemaChargesList = [];
        let checkFlag = true;
        if (this.AllCinemaChargeSettingsArray.length) {
          let tempCinemaTaxSettings = this.AllCinemaChargeSettingsArray.filter(
            (x) =>
              x.cinema_id == id &&
              x.pas_charge_setting_name ==
                this.CinemaPriceSettings[index].selectedChargeSettingName
          );
          if (tempCinemaTaxSettings && tempCinemaTaxSettings.length) {
            let selectedChargeSetting = tempCinemaTaxSettings[0];
            this.CinemaPriceSettings[index].cinemaChargesList =
              selectedChargeSetting["charge_array"];
            let promises = this.CinemaPriceSettings[
              index
            ].cinemaChargesList.map((x) => {
              x["cinemacharges"] = 0;
              return x;
            });
            await Promise.all(promises).then(() => {
              this.cinemaChargesCalculation(index);
            });
          } else {
            checkFlag = false;
          }
        } else {
          checkFlag = false;
        }
        if (!checkFlag) {
          let payload = {
            pas_charge_setting_name: this.CinemaPriceSettings[index]
              .selectedChargeSettingName,
            id: id,
          };
          CinemasService.GetCinemaChargesByCinemaId(payload)
            .then(async (response) => {
              const { data } = response;
              if (data && data.status && data.Records.length > 0) {
                this.CinemaPriceSettings[index].cinemaChargesList =
                  data.Records;
                let promises = this.CinemaPriceSettings[
                  index
                ].cinemaChargesList.map((x) => {
                  x["cinemacharges"] = 0;
                  return x;
                });
                await Promise.all(promises).then(() => {
                  this.cinemaChargesCalculation(index);
                });
              } else {
                // Show Error Message Here
                console.log("data.message :", data.message);
              }
            })
            .catch((error) => {
              // Show Catch Error
              console.log("catch error on GetCinemaCharges :", error);
            });
        }
      },
      onSearchFoodCategories: function() {
        if (this.searchFoodCategories && this.searchFoodCategories.length > 0) {
          this.ms_food_categories = this.ms_food_categoriesCopy.filter((x) => {
            if (
              x.fc_category
                .toLowerCase()
                .includes(this.searchFoodCategories.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.ms_food_categories = this.ms_food_categoriesCopy;
        }
      },
      onRemoveFnbItem: function(fnbItem, index) {
        this.CinemaPriceSettings[index].itemcost_price.item_id = null;
        this.CinemaPriceSettings[index].itemcost_price.costprice = 0;
      },
      onSelectFnbItem: function(fnbItem, index) {
        this.CinemaPriceSettings[index].itemcost_price.item_id = parseInt(
          fnbItem.recipe_id
        );

        this.getItemCostPriceNew(
          this.CinemaPriceSettings[index].itemcost_price.cinema_id,
          fnbItem.recipe_id,
          index
        );
      },
      setModalData(height, width) {
        this.set_height = height;
        this.set_width = width;
        this.showModal = !this.showModal;
      },
      showFnbImage: function() {
        console.log("object");
        this.$refs["preview-modal"].show();
      },
      onChangeWeekdays: function(event, keyname, index) {
        if (keyname === "AllDays" && event) {
          Object.keys(this.CinemaPriceSettings[index].weekDays).map((x) => {
            x !== "AllDays"
              ? (this.CinemaPriceSettings[index].weekDays[x] = true)
              : "";
          });
        } else if (keyname === "AllDays" && !event) {
          Object.keys(this.CinemaPriceSettings[index].weekDays).map((x) => {
            x !== "AllDays"
              ? (this.CinemaPriceSettings[index].weekDays[x] = false)
              : "";
          });
        }
        setTimeout(() => {
          this.checkWeekDays();
        }, 100);
      },
      onSearchCustomization: function() {
        if (this.searchCustomization && this.searchCustomization.length > 0) {
          this.customizations = this.customizationsCopy.filter((x) => {
            if (
              x.customization_name
                .toLowerCase()
                .includes(this.searchCustomization.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.customizations = this.customizationsCopy;
        }
      },
      getFnbItemDetails: function() {
        let loader = this.$loading.show();
        PosFnbService.GetFnbItem({
          item_code: this.fnb_item.item_code,
          onlyActive: this.onlyActive,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              for (var i = 0; i < data.Records.length - 1; i++) {
                this.addCinemaSetting();
              }
              data.Records.map((x, index) => {
                this.CinemaPriceSettings[index]["item_id"] = x.item_id;
                this.CinemaPriceSettings[index]["isLoading"] = false;
                this.CinemaPriceSettings[index]["isNewCinema"] = false;
                if (x.recipe_id) {
                  this.CinemaPriceSettings[index]["selected_recipe_name"] = {
                    recipe_id: x.recipe_id,
                    recipe_name: x.recipe_name,
                  };
                  this.CinemaPriceSettings[index].itemcost_price.item_id =
                    x.recipe_id;
                } else {
                  this.CinemaPriceSettings[index].itemcost_price.item_id = null;
                  this.CinemaPriceSettings[index]["selected_recipe_name"] = "";
                }
                this.getItemCostPrice(x.item_id, index);
              });
              if (data.Records[0].has_modifiers == "Y") {
                let ItemIds = data.Records.map((IDS) => IDS.item_id);
                this.callGetModifierDetails(ItemIds);
              }
              this.fnb_item = data.Records[0];
              this.fnbId = data.Records[0].item_id;
              this.getMovieContentLangauge(data.FnbContent);
              // this.customization_name = data.Records[0].customization_name;
              this.fnb_item.is_sundry = data.Records[0].is_sundry || "N";
              this.fnb_item.is_combo = data.Records[0].is_combo || "N";
              this.fnb_item.has_modifiers =
                data.Records[0].has_modifiers || "N";
              this.fnb_item.is_premier_item =
                data.Records[0].is_premier_item || "N";
              this.fnb_item.is_non_sellable_product =
                data.Records[0].is_non_sellable_product || "N";
              this.fnb_item.ready_to_serve =
                data.Records[0].ready_to_serve || "N";
              this.fnb_item.item_is_veg =
                this.fnb_item.item_is_veg == "Y" ? true : false;
              this.fnb_item.includes_egg =
                this.fnb_item.includes_egg == "Y" ? true : false;

              this.fnb_item.is_package_item =
                this.fnb_item.is_package_item == "Y" ? true : false;

              this.fnb_item.item_is_active =
                this.fnb_item.item_is_active == "Y" ? true : false;

              this.fnb_item.selected_customizations = [];

              this.recipe_label = this.fnb_item.recipe_name;
              this.fc_parent_label = this.fnb_item.fc_category;
              this.getCustomizationList(data.FnbCustomizations);
              if (data.FnbCustomizations && data.FnbCustomizations.length > 0) {
                this.sectionCollapse.customizationBlock = true;
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 3000);
          });
      },
      getItemCostPriceNew: function(cinema_id, item_id, index) {
        if (cinema_id && item_id) {
          PosFnbService.GetItemsCostPrice({ cinema_id, item_id })
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.CinemaPriceSettings[
                  index
                ].itemcost_price.costprice = parseFloat(
                  data.ItemCostPrice
                ).toFixed(this.MIN_FRACTION_DIGITS);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      },
      getCurrencyCode: function(currencyid) {
        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
          curr_id: currencyid,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.currencyData = data.Records[0];
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      },
      getItemCostPrice: function(item_id, index) {
        let payload = {
          tableName: "item_cost_price",
          itc_is_active: "Y",
          item_id: item_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              // this.recipes = data.Records;
              // console.log("ITC", data.Records);
              // let obj = data.Records[0];
              // for (var i = 0; i < data.Records.length - 1; i++) {
              //   this.addCinemaSetting();
              // }

              data.Records.map((obj) => {
                this.occupiedCinemas.push({
                  cine_id: obj.cinema_id,
                  arrayIndex: index,
                });
                this.getCinemaName(obj.cinema_id, index);
                this.getPasSettingName(obj.cinema_id, index);
                this.CinemaPriceSettings[index].cinema_id = obj.cinema_id;
                this.CinemaPriceSettings[index].recipe_label =
                  this.CinemaPriceSettings[index].itemcost_price.item_id &&
                  String(this.CinemaPriceSettings[index].itemcost_price.item_id)
                    .length > 0
                    ? this.recipe_label
                    : "";
                this.CinemaPriceSettings[index].itemcost_price.cinema_id =
                  obj.cinema_id;
                this.CinemaPriceSettings[index].itemcost_price.itc_id =
                  obj.itc_id;
                // this.CinemaPriceSettings[
                //   index
                // ].itemcost_price.item_id = this.fnb_item.item_id;
                this.CinemaPriceSettings[index].itemcost_price.costprice =
                  obj.itc_cost_price;
                this.CinemaPriceSettings[index].itemcost_price.fp_is_active =
                  obj.itc_is_active;
              });
              this.getFnbPricing(item_id, index);
              this.getComboDetails(
                item_id,
                index,
                this.CinemaPriceSettings[index].cinema_id
              );
              this.getMultipleCinemasData();
              console.log("this.occupiedCinemas :>> ", this.occupiedCinemas);
            } else {
              console.log("message", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getMultipleCinemasData: function() {
        MasterService.getMultipleCinemasData(this.occupiedCinemas)
          .then((response) => {
            const { data } = response;

            if (data.status && data.status) {
              if (data.Records && data.Records.length > 0) {
                this.occupiedCinemas.map((x) => {
                  data.Records.filter((y) => {
                    if (y.cine_id == x.cine_id) {
                      this.CinemaPriceSettings[x.arrayIndex].selectedCinema =
                        y.cine_name;
                      this.CinemaPriceSettings[x.arrayIndex].cinemaFlag = true;
                      this.CinemaPriceSettings[
                        x.arrayIndex
                      ].selectedCinemas.push(y);
                    }
                  });

                  // this.cinemaListCopy.filter((z, index) => {
                  //   if (z.cine_id == x.cine_id) {
                  //     this.cinemaListCopy.splice(index, 1);
                  //   }
                  // });
                });
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getCinemaName(cinema_id, index) {
        this.cinemaList.map((x) => {
          if (String(cinema_id) == String(x.cine_id)) {
            this.CinemaPriceSettings[index].selectedCinema = x.cine_name;
            this.CinemaPriceSettings[index].selectedCinemas.push(x);
          }
        });
      },
      getCustomizationList: function(customizationArray = []) {
        let payload = {
          limit: null,
          currentPage: null,
          searchKey: "",
          searchValue: "",
        };
        PosFnbService.GetActiveCustomizationList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.customizations = data.Records;
              this.customizationsCopy = data.Records;
              if (customizationArray.length > 0) {
                customizationArray.map((x) => {
                  let selectedItem =
                    this.customizations.filter(
                      (y) => y.item_id == x.customization_id
                    ) || {};
                  let obj = {
                    fcm_id: x.fcm_id,
                    customization_id: x.customization_id,
                    selectedCustomization: selectedItem,
                    is_compulsory: x.is_compulsory,
                  };
                  this.customizationMap.push(obj);
                });
              }
              // this.customizations.map(x => {
              //   if (x.customization_common_id == customization_common_id) {
              //     this.customization_name = x.customization_name;
              //     return;
              //   }
              // });
            } else {
              console.log("message", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      onSelectCustomization(value) {
        this.customization_name = value.customization_name;
        this.fnb_item["customization_common_id"] =
          value.customization_common_id;
      },
      addCinemaSetting: function(index) {
        this.getGlobalOptions();
        let cinemaSettingObj = {
          selectedCinema: "",
          cinema_id: null,
          item_id: null,
          isNewCinema: true,
          selectedCinemas: [],
          combo_pack: [],
          modifier_pack: [],
          fnb_item_array: [],

          recipe_label: "",
          //ITEM COST PRICE
          itemcost_price: {
            itc_id: "",
            cinema_id: "",
            v_id: "",
            item_id: null,
            costprice: "",
            fp_is_active: true,
          },
          report_code: "",
          gl_account: "",
          gl_desc: "",
          //RATE CARD

          selectedCinema: "",
          cinemaList: [],
          currencyData: [],
          ratecard: {
            frc_id: null,
            cinema_id: null,
            frc_name: Math.floor(1000 + Math.random() * 9000),
            frc_amount: "",
            currency_id: null,
            frc_is_active_inclusivtax: "Y",
            frc_is_active: "N",
            frc_net_amount: 0,
            frc_total_amount: 0,
            curr_code: null,
          },
          selectedChargeSettingName: "",
          pas_setting_name_list: [],
          cinemaChargesList: [],
          //FNB Pricing
          weekDays: {
            AllDays: true,
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            sunday: true,
          },
          ms_fnb_price: {
            fp_id: "",
            cinema_id: "",
            item_id: null,
            currency_id: "",
            fp_id: "",
            fnb_rate_card_id: "",
            fp_amount: "",
            fp_total_amount: "",
            fp_from_date: new Date(),
            fp_to_date: "",
            fp_is_active: true,
            fp_sunday: true,
            fp_monday: true,
            fp_tuesday: true,
            fp_wednesday: true,
            fp_thursday: true,
            fp_friday: true,
            fp_saturday: true,
          },
        };

        if (this.fnb_item.is_combo == "Y") {
          this.selectedComboCategory.forEach((category) => {
            let categoryObj = {
              category_id: category.fc_id,
              category_name: category.fc_category,
              alternate_items: [],
              quantity: 1,
              min_quantity: 1,
              max_quantity: 1,
              min_max_setting: "N",
              default_item: "",
              default_item_id: null,
              default_item_name: "",
            };
            cinemaSettingObj["combo_pack"].push(categoryObj);
          });
        }
        if (this.fnb_item.has_modifiers == "Y") {
          this.selectedModifierCategory.forEach((category) => {
            let categoryObj = {
              category_id: category.category_id,
              category_name: category.category_name,
              alternate_items: [],
              quantity: 1,
              uom_id: null,
              selectedUom: "",
              non_mandatory_modifier: "N",
              default_item: "",
              default_item_id: null,
              default_item_name: "",
              mappedArray: category.mappedArray,
              uomList: [],
            };
            cinemaSettingObj["modifier_pack"].push(categoryObj);
          });
        }

        this.CinemaPriceSettings.push(cinemaSettingObj);
      },
      setDaysValue: function(voucherDays, index) {
        let days = {
          monday: "fp_monday",
          tuesday: "fp_tuesday",
          wednesday: "fp_wednesday",
          thursday: "fp_thursday",
          friday: "fp_friday",
          saturday: "fp_saturday",
          sunday: "fp_sunday",
        };
        if (voucherDays) {
          Object.keys(days).map((x) => {
            this.CinemaPriceSettings[index].weekDays[x] =
              voucherDays[days[x]] === "Y" ? true : false;
          });

          let array = Object.keys(
            this.CinemaPriceSettings[index].weekDays
          ).filter(
            (x) =>
              x !== "AllDays" && !this.CinemaPriceSettings[index].weekDays[x]
          );
          if (array.length === 0) {
            this.CinemaPriceSettings[index].weekDays["AllDays"] = true;
          }
        }
      },
      onChangeRatecardAmount: function(event, index) {
        this.cinemaChargesCalculation(index);
      },
      OnSwitchHandler: function(event, index) {
        this.CinemaPriceSettings[
          index
        ].ratecard.frc_is_active_inclusivtax = event;
        this.cinemaChargesCalculation(index);
      },
      getComboDetails(item_id, index, cinema_id) {
        if (this.comboDetailsLoader) {
          this.comboDetailsLoader.hide();
        }
        this.comboDetailsLoader = this.$loading.show();
        this.cinemaLoader = true;
        let payload = {
          item_id: item_id,
        };
        PosFnbService.GetComboDetails(payload)
          .then((response) => {
            const { data } = response;
            if (
              data &&
              data.status &&
              data.Records &&
              data.Records.length > 0
            ) {
              this.selectedComboCategory = [];
              data.Records.map((combo) => {
                // if (
                //   !this.selectedComboCategory.some(
                //     (check) => check.fc_id == combo.category_id
                //   )
                // ) {
                //   this.selectedComboCategory.push(combo.selected_category);
                // }
                this.selectedComboCategory.push(combo.selected_category);
              });
              this.CinemaPriceSettings[index].combo_pack = _.cloneDeep(
                data.Records
              );
              if (this.fnb_item.is_combo == "Y") {
                this.getComboCinemaList(cinema_id, index);
              }
            } else {
              console.log("Error", data.message);
            }
          })
          .catch((err) => {
            console.log("Error", err);
          })
          .finally(() => {
            this.comboDetailsLoader.hide();
            this.cinemaLoader = false;
          });
      },
      callGetModifierDetails(itemsIds = []) {
        let modifierPack = [];
        let payload = {
          itemsIdsArray: itemsIds,
        };
        PosFnbService.GetFnbModifierDetails(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              modifierPack = data.Records;
              this.UomList =
                data.hasOwnProperty("UOMList") && data["UOMList"]
                  ? data["UOMList"]
                  : [];
              this.modifierCatergories =
                data.hasOwnProperty("modifierCatergories") &&
                data["modifierCatergories"]
                  ? data["modifierCatergories"]
                  : [];
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            if (modifierPack.length) {
              modifierPack.forEach((_cat) => {
                if (
                  !this.selectedModifierCategory.some(
                    (_selectedCategory) =>
                      _selectedCategory["category_id"] == _cat["category_id"]
                  )
                ) {
                  this.selectedModifierCategory.push(_cat["selected_category"]);
                }
              });
              console.log(
                "this.selectedModifierCategory",
                this.selectedModifierCategory
              );
              this.CinemaPriceSettings.map((_itemClass) => {
                _itemClass["modifier_pack"] = modifierPack.filter(
                  (_pack) => _pack["item_id"] == _itemClass["item_id"]
                );
              });
            }
          });
      },
      getFnbPricing: function(item_id, index) {
        let payload = {
          tableName: "ms_fnb_price",
          fp_is_active: "Y",
          item_id: item_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              // this.recipes = data.Records;
              // console.log("ITC", data.Records);
              // let obj = data.Records[0];
              data.Records.map((obj) => {
                // this.ms_fnb_price = obj;
                this.setDaysValue(obj, index);
                this.CinemaPriceSettings[index].ms_fnb_price.item_id = item_id;
                this.CinemaPriceSettings[index].ms_fnb_price.fp_id = obj.fp_id;
                this.CinemaPriceSettings[index].report_code =
                  obj.report_code || null;
                this.CinemaPriceSettings[index].gl_account =
                  obj.gl_account || null;
                this.CinemaPriceSettings[index].gl_desc = obj.gl_desc || null;
                this.CinemaPriceSettings[index].ms_fnb_price.cinema_id =
                  obj.cinema_id;
                this.CinemaPriceSettings[index].ms_fnb_price.fnb_rate_card_id =
                  obj.fnb_rate_card_id;
                this.CinemaPriceSettings[
                  index
                ].ms_fnb_price.fp_from_date = new Date(obj.fp_from_date);
                this.CinemaPriceSettings[index].ms_fnb_price.fp_to_date =
                  obj.fp_to_date && isValidDate(new Date(obj.fp_to_date))
                    ? new Date(obj.fp_to_date)
                    : "";
                this.getEditRatecardList(obj.fnb_rate_card_id, index);
              });
              function isValidDate(d) {
                if (Object.prototype.toString.call(d) === "[object Date]") {
                  // it is a date
                  if (isNaN(d.getTime())) {
                    return false;
                    // d.valueOf() could also work
                    // date is not valid
                  } else {
                    return true;
                    // date is valid
                  }
                } else {
                  return false;
                  // not a date
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getEditRatecardList: function(id, index) {
        PosFnbService.GetRatecardById({ id })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.CinemaPriceSettings[index].ratecard = {
                  ...this.CinemaPriceSettings[index].ratecard,
                  ...data.Records[0],
                };
                if (data.Records[0]["frc_pas_setting_name"]) {
                  this.CinemaPriceSettings[index][
                    "selectedChargeSettingName"
                  ] = data.Records[0]["frc_pas_setting_name"]
                    ? data.Records[0]["frc_pas_setting_name"]
                    : "";
                }
                // this.getCinemaList(data.Records[0].cinema_id);
                // this.ratecard.currency_id = data.Records[0].curr_id;
                this.CinemaPriceSettings[index].cinemaChargesList =
                  data.Records[0].chargesList || [];
                this.cinemaChargesCalculation(index);
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      cinemaChargesCalculation: function(index) {
        this.CinemaPriceSettings[index].ratecard.frc_net_amount = parseFloat(
          this.CinemaPriceSettings[index].ratecard.frc_amount
        );
        this.CinemaPriceSettings[index].ratecard.frc_total_amount = parseFloat(
          this.CinemaPriceSettings[index].ratecard.frc_amount
        );

        let FinalAmount = parseFloat(
          this.CinemaPriceSettings[index].ratecard.frc_total_amount || 0
        );
        if (this.qfx_tax_structure) {
          console.log("CALC qfx_tax_structure");
          let grosss = this.getSafe(
            () =>
              this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
            []
          )
            .filter((g) =>
              String(g.ct_name)
                .toUpperCase()
                .includes("VAT")
            )
            .filter((g) => g.pas_is_percentage === "Y");

          let nets = this.getSafe(
            () =>
              this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
            []
          )
            .filter(
              (g) =>
                !String(g.ct_name)
                  .toUpperCase()
                  .includes("VAT")
            )
            .filter((g) => g.pas_is_percentage === "Y");

          let misc_products = this.getSafe(
            () =>
              this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
            []
          )
            .filter((g) => g.pas_is_percentage === "N")
            .filter(
              (g) =>
                !String(g.ct_name)
                  .toUpperCase()
                  .includes("VAT")
            );

          console.log({
            nets,
            grosss,
            misc_products,
            taxes: this.CinemaPriceSettings[index].cinemaChargesList.map(
              (x) => x
            ),
          });

          let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
          let vat_percent = this.getFloat(
            this.getSafe(() => grosss[0].pas_charge_value, 0),
            2
          );

          let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
          let net_1_percent = this.getFloat(
            this.getSafe(() => nets[0].pas_charge_value, "0"),
            2
          );

          let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
          let net_2_percent = this.getFloat(
            this.getSafe(() => nets[1].pas_charge_value, "0"),
            2
          );

          let misc_product_rate_pas_id = this.getSafe(
            () => misc_products[0].pas_id
          );
          let misc_product_rate_1 = this.getFloat(
            this.getSafe(() => misc_products[0].pas_charge_value, "0"),
            2
          );
          let misc_rate_exist =
            misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
          let amount = this.getFloat(FinalAmount);

          /** Gross */
          let G = amount;
          /** Taxable/Net */
          let E = this.getFloat(amount / (1 + vat_percent / 100));
          /** VAT */
          let F = this.getFloat((vat_percent / 100) * E);
          /** 3D/Prod */
          let B = this.getFloat(misc_product_rate_1 / (1 + vat_percent / 100));
          /** Ticket Rate */
          let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
          let A = this.getFloat((E - B) / totalPerCentOfA);
          /** Film Dev Tax */
          let C = this.getFloat((net_1_percent / 100) * A);
          /** State & Local Ent Tax */
          let D = this.getFloat((net_2_percent / 100) * A);

          console.log({
            amount,
            vat_percent,
            net_1_percent,
            net_2_percent,
            totalPerCentOfA,
            misc_rate_exist,
            misc_product_rate_1,
          });
          console.log({
            Gross: G,
            Net: E,
            VAT: F,
            FDT: C,
            SLE: D,
            "3D": B,
            TicketRate: A,
            ProductRate: B,
          });

          let NET_AMT = E;
          let BASE_RATE = A;
          let NET_1_AMT = C;
          let NET_2_AMT = D;
          let NET_3_AMT = B; // misc_product_rate_1
          let VAT_AMT = F;
          let Gross = G;

          this.CinemaPriceSettings[index].cinemaChargesList.map((x, i) => {
            if (x.pas_id == vat_pas_id) {
              x.cinemacharges = VAT_AMT;
            }
            if (x.pas_id == net_1_pas_id) {
              x["cinemacharges"] = NET_1_AMT;
            }
            if (x.pas_id == net_2_pas_id) {
              x["cinemacharges"] = NET_2_AMT;
            }
            if (x.pas_id == misc_product_rate_pas_id) {
              x["cinemacharges"] = NET_3_AMT;
            }
          });

          this.CinemaPriceSettings[
            index
          ].ratecard.frc_net_amount = this.getFloat(BASE_RATE + NET_3_AMT);

          this.$forceUpdate();
        } else if (this.mif_tax_calculation) {
          let grosss = this.getSafe(
            () =>
              this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
            []
          )
            .filter((g) =>
              String(g.ct_name)
                .toUpperCase()
                .includes("VAT")
            )
            .filter((g) => g.pas_is_percentage === "Y");

          let nets = this.getSafe(
            () =>
              this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
            []
          )
            .filter(
              (g) =>
                !String(g.ct_name)
                  .toUpperCase()
                  .includes("VAT")
            )
            .filter((g) => g.pas_is_percentage === "Y");

          let misc_products = this.getSafe(
            () =>
              this.CinemaPriceSettings[index].cinemaChargesList.map((x) => x),
            []
          )
            .filter((g) => g.pas_is_percentage === "N")
            .filter(
              (g) =>
                !String(g.ct_name)
                  .toUpperCase()
                  .includes("VAT")
            );

          console.log({
            nets,
            grosss,
            misc_products,
            taxes: this.CinemaPriceSettings[index].cinemaChargesList.map(
              (x) => x
            ),
          });

          let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
          let vat_percent = this.getFloat(
            this.getSafe(() => grosss[0].pas_charge_value, 0),
            2
          );

          let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
          let net_1_percent = this.getFloat(
            this.getSafe(() => nets[0].pas_charge_value, "0"),
            2
          );

          let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
          let net_2_percent = this.getFloat(
            this.getSafe(() => nets[1].pas_charge_value, "0"),
            2
          );

          let misc_product_rate_pas_id = this.getSafe(
            () => misc_products[0].pas_id
          );
          let misc_product_rate_1 = this.getFloat(
            this.getSafe(() => misc_products[0].pas_charge_value, "0"),
            2
          );

          let all_mis_product_sum = 0;
          if (misc_products && misc_products.length) {
            all_mis_product_sum =
              this.getFloat(
                misc_products.reduce(
                  (acc, { pas_charge_value }) =>
                    acc + parseFloat(pas_charge_value),
                  0
                ),
                3
              ) || 0;
          }

          let misc_rate_exist =
            misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
          let amount = this.getFloat(FinalAmount);

          /** Gross */
          let G = amount;
          /** Taxable/Net */
          let E = this.getFloat(amount / (1 + vat_percent / 100));
          /** VAT */
          let F = this.getFloat((vat_percent / 100) * E);
          /** 3D/Prod */
          let B = this.getFloat(all_mis_product_sum || 0);
          /** Ticket Rate */
          let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
          let A = this.getFloat((E - B) / totalPerCentOfA);
          /** Film Dev Tax */
          let C = this.getFloat((net_1_percent / 100) * A);
          /** State & Local Ent Tax */
          let D = this.getFloat((net_2_percent / 100) * A);

          console.log({
            amount,
            vat_percent,
            net_1_percent,
            net_2_percent,
            totalPerCentOfA,
            misc_rate_exist,
            misc_product_rate_1,
          });
          console.log({
            Gross: G,
            Net: E,
            VAT: F,
            FDT: C,
            SLE: D,
            "3D": B,
            TicketRate: A,
            ProductRate: B,
          });

          let NET_AMT = E;
          let BASE_RATE = A;
          let NET_1_AMT = C;
          let NET_2_AMT = D;
          let NET_3_AMT = B; // misc_product_rate_1
          let VAT_AMT = F;
          let Gross = G;

          this.CinemaPriceSettings[index].cinemaChargesList.map((x, i) => {
            if (x.pas_id == vat_pas_id) {
              x.cinemacharges = this.getFloat(VAT_AMT, 2);
            }
            if (x.pas_id == net_1_pas_id) {
              x["cinemacharges"] = this.getFloat(NET_1_AMT, 2);
            }
            if (x.pas_id == net_2_pas_id) {
              x["cinemacharges"] = this.getFloat(NET_2_AMT, 2);
            }
            if (x.pas_is_percentage == "N") {
              let findIndex = misc_products.findIndex(
                (mis) => mis.pas_id == x.pas_id
              );

              if (findIndex > -1) {
                x.cinemacharges = parseFloat(
                  misc_products[findIndex]["pas_charge_value"]
                ).toFixed(2);
              }
            }
          });

          // this.CinemaPriceSettings[index].ratecard.frc_net_amount = this.getFloat(
          //   BASE_RATE + NET_3_AMT
          // );
          this.CinemaPriceSettings[
            index
          ].ratecard.frc_net_amount = this.getFloat(BASE_RATE);

          this.$forceUpdate();
        } else {
          this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
            if (
              this.CinemaPriceSettings[index].ratecard
                .frc_is_active_inclusivtax === "N"
            ) {
              if (x.pas_is_percentage === "Y") {
                x.cinemacharges =
                  (parseFloat(
                    this.CinemaPriceSettings[index].ratecard.frc_amount
                  ) *
                    parseFloat(x.pas_charge_value)) /
                  100;
              }
              this.calculateNetAmount(x, "Plus", index);
            } else if (
              this.CinemaPriceSettings[index].ratecard
                .frc_is_active_inclusivtax === "Y"
            ) {
              if (x.pas_is_percentage === "Y") {
                x.cinemacharges =
                  ((parseFloat(
                    this.CinemaPriceSettings[index].ratecard.frc_amount
                  ) /
                    this.calculatePercentageCharge(index)) *
                    parseFloat(x.pas_charge_value)) /
                  100;
              }
              this.calculateNetAmount(x, "Minus", index);
            }
            if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
              x.cinemacharges =
                parseFloat(x.pas_charge_value) *
                this.calculateTaxableCharge(index);
            } else if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "N"
            ) {
              x.cinemacharges = parseFloat(x.pas_charge_value);
            }
            return x;
          });
          this.$forceUpdate();
        }
      },
      getFloat(val = "0", fractionDigits = this.fractionDigits) {
        let parsed = parseFloat(String(val) || "0") || parseFloat("0");
        return +parseFloat(parsed.toFixed(fractionDigits));
      },
      calculatePercentageCharge: function(index) {
        let finalvalue = 1;
        this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
          if (x.pas_is_percentage === "Y") {
            finalvalue += parseFloat(x.pas_charge_value) / 100;
          }
        });
        return finalvalue;
      },
      calculateNetAmount: function(x, equation, index) {
        if (equation === "Plus") {
          if (x.pas_is_percentage === "Y") {
            this.CinemaPriceSettings[
              index
            ].ratecard.frc_total_amount += parseFloat(x.cinemacharges);
          } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
            this.CinemaPriceSettings[
              index
            ].ratecard.frc_total_amount += parseFloat(x.pas_charge_value);
          } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
            this.CinemaPriceSettings[
              index
            ].ratecard.frc_total_amount += parseFloat(x.pas_charge_value);
          }
        } else if (equation === "Minus") {
          if (x.pas_is_percentage === "Y") {
            this.CinemaPriceSettings[
              index
            ].ratecard.frc_net_amount -= parseFloat(x.cinemacharges);
          } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
            this.CinemaPriceSettings[
              index
            ].ratecard.frc_net_amount -= parseFloat(x.pas_charge_value);
          } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
            this.CinemaPriceSettings[
              index
            ].ratecard.frc_net_amount -= parseFloat(x.pas_charge_value);
          }
        }
      },
      removeCinemaSettings: function(cinemaIndex) {
        if (
          this.role_id == 3 &&
          this.CinemaPriceSettings[cinemaIndex].cinemaFlag
        ) {
          this.$toasted.show(
            "You are not authorized to remove other cinemas details."
          );
        } else {
          this.removedPriceDetails.push(this.CinemaPriceSettings[cinemaIndex]);
          console.log(
            "this.removedPriceDetails :>> ",
            this.removedPriceDetails
          );
          this.CinemaPriceSettings.splice(cinemaIndex, 1);
        }
      },
      calculateTaxableCharge: function(index) {
        let finalvalue = 1;
        this.CinemaPriceSettings[index].cinemaChargesList.map((x) => {
          //Pick only items that are taxable
          if (x.pas_is_percentage === "Y") {
            finalvalue -= parseFloat(x.pas_charge_value) / 100;
          }
        });
        return finalvalue;
      },
      onDropdownChange: function(item, index) {
        // this.cinemaListCopy.push(item.cine_id);
        this.CinemaPriceSettings[index].selectedCinema = item.cine_name;
        this.CinemaPriceSettings[index].cinema_id = item.cine_id;
        this.CinemaPriceSettings[index].itemcost_price.cinema_id = item.cine_id;
        this.CinemaPriceSettings[index].ms_fnb_price.cinema_id = item.cine_id;
        this.CinemaPriceSettings[index].ratecard.cinema_id = item.cine_id;
        // this.cinemaListCopy = [];
        // this.cinemaList.map((x) => {
        //   let arr = this.CinemaPriceSettings.filter((y) => {
        //     return y.cinema_id == x.cine_id;
        //   });
        //   if (arr.length == 0) {
        //     this.cinemaListCopy.push(x);
        //   }
        // });
        // this.cinemaListCopy.map((x, index) => {
        //   if (x.cine_id == item.cine_id) {
        //     this.cinemaListCopy.splice(index, 1);
        //   }
        // });
        if (this.fnb_item.is_combo == "Y") {
          this.getComboCinemaList(item.cine_id, index);
        }
        if (item.currency_id == null && item.currency_id == "") {
          this.secureStore.get("BRGLOPCU") &&
            this.secureStore.get("BRGLOPCU").go_value;
        } else {
          this.getCurrencyCode(item.currency_id);
        }
        this.getPasSettingName(item.cine_id, index);
      },
      getPasSettingName: function(id, index) {
        this.CinemaPriceSettings[index].pas_setting_name_list = [];
        if (this.AllCinemaChargeSettingsArray.length) {
          this.CinemaPriceSettings[
            index
          ].pas_setting_name_list = this.AllCinemaChargeSettingsArray.filter(
            (x) => x.cinema_id == id
          );
        } else {
          CinemasService.GetCinemaSettingNameByCinemaId({ id })
            .then(async (response) => {
              const { data } = response;
              if (data && data.status && data.Records.length > 0) {
                this.CinemaPriceSettings[index].pas_setting_name_list =
                  data.Records;
              } else {
                // Show Error Message Here
                this.$toasted.show(data.message);
              }
            })
            .catch((error) => {
              // Show Catch Error
              this.$toasted.show(error);
            });
        }
      },
      getGlobalOptions: function() {
        MasterService.GetGlobalOptions()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              data.Records.map((x) => {
                if (x.go_key === "CURRENCY") {
                  this.CinemaPriceSettings.map((y, index) => {
                    this.CinemaPriceSettings[index].ratecard.currency_id =
                      x.go_value || null;
                    this.CinemaPriceSettings[index].ms_fnb_price.currency_id =
                      x.go_value || null;
                  });
                }
              });
            } else {
              // Show Error
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            //Catch Error
            console.log("catch error on GetGlobalOptions :", error);
          });
      },
      getCinemaList: function(cinema_id) {
        // let body = this.getRequestBody("GET", undefined, {
        //   GET: "/admin/",
        //   tableName: "ms_cinemas"
        // });
        MasterService.GetCinemas({ cine_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.cinemaList = data.Records;
                this.cinemaListCopy = data.Records;
                this.cinemaList.map((x) => {
                  if (String(cinema_id) == String(x.cine_id)) {
                    // this.selectedCinema = x.cine_name;
                  }
                });
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getRecipeList: function() {
        let payload = {
          tableName: "ms_recipes",
          recipe_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.recipes = data.Records;
            } else {
              console.log("Error", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            console.log("Error", err);
            // this.$toasted.show(error);
          });
      },
      getFoodCategoiresList: function() {
        let payload = {
          tableName: "ms_food_categories",
          fc_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ms_food_categories = data.Records;
              this.ms_food_categoriesCopy = data.Records;
            } else {
              console.log("Error", data.message);
              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            console.log("Error", error);
            // this.$toasted.show(error);
          });
      },

      // setImage: function(e) {
      //   this.file = e.target.files[0];
      //   this.filename = e.target.files[0]["name"];

      //   // console.log("file.type.indexOf :", file.type);
      //   if (this.file.type.indexOf("image/") === -1) {
      //     this.$toasted.show("Please select an image file");
      //     return;
      //   }
      //   if (typeof FileReader === "function") {
      //     const reader = new FileReader();
      //     reader.onload = event => {
      //       this.imgSrc = event.target.result;
      //       this.width = 129;
      //       this.height = 192;
      //       // this.$cropper.setAspectRatio(1);
      //       // rebuild cropperjs with the updated source
      //       this.$bvModal.show("imagecropper");
      //       e.target.value = "";
      //     };
      //     reader.readAsDataURL(this.file);
      //   } else {
      //     // alert("Sorry, FileReader API not supported");
      //   }
      // },

      // cropImage() {
      //   // get image data for post processing, e.g. upload or setting image src
      //   this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      //   // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      //   var block = this.cropImg.split(";");
      //   // Get the content type of the image
      //   var contentType = block[0].split(":")[1]; // In this case "image/gif"
      //   // get the real base64 content of the file
      //   var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      //   // Convert it to a blob to upload
      //   var blob1 = this.b64toBlob(realData, contentType);
      //   this.uploadImage(blob1, this.filename);
      // },
      // b64toBlob(b64Data, contentType, sliceSize) {
      //   contentType = contentType || "";
      //   sliceSize = sliceSize || 512;

      //   var byteCharacters = atob(b64Data);
      //   var byteArrays = [];

      //   for (
      //     var offset = 0;
      //     offset < byteCharacters.length;
      //     offset += sliceSize
      //   ) {
      //     var slice = byteCharacters.slice(offset, offset + sliceSize);

      //     var byteNumbers = new Array(slice.length);
      //     for (var i = 0; i < slice.length; i++) {
      //       byteNumbers[i] = slice.charCodeAt(i);
      //     }

      //     var byteArray = new Uint8Array(byteNumbers);

      //     byteArrays.push(byteArray);
      //   }

      //   var blob = new Blob(byteArrays, { type: contentType });
      //   return blob;
      // },

      // uploadImage: function(image, filename) {
      //   let loader = this.$loading.show();

      //   let self = this;
      //   let formData = new FormData();
      //   formData.append("image", image, filename);
      //   formData.append("imagePath", "FnB Item Image");
      //   MasterService.GlobalUploadImage(formData)
      //     .then(response => {
      //       const { data } = response;
      //       data.message ? this.$toasted.show(data.message) : "";
      //       if (data.status) {
      //         self.fnb_item.item_image_url = data.path;
      //         this.$bvModal.hide("imagecropper");
      //       }
      //       self.BaseURL = data.BaseURL;
      //     })
      //     .catch(error => {
      //       alert(
      //         "Sorry! Something went wrong. kindly contact your administrator"
      //       );
      //     })
      //     .finally(() => {
      //       setTimeout(() => loader.hide(), 1000);
      //     });
      // },

      onResetForm: function() {
        this.fnb_item = {
          fc_id: "",
          item_code: "",
          item_description: "",
          fi_order: null,
          item_age_restriction: "",
          recipe_id: "",
          item_is_veg: true,
          includes_egg: true,
          ready_to_serve: "N",
          is_premier_item: "N",
          is_non_sellable_product: "N",
          item_is_recipe: "",
          item_image_url: "",
          item_is_active: false,
          selected_customizations: [],
        };
        this.recipe_label = "";
        this.fc_parent_label = "";
      },
      validatePricing(showErr = true) {
        let errCount = 0;
        let errMsg = ``;

        this.CinemaPriceSettings.forEach((x, index) => {
          if (!x.selectedChargeSettingName) {
            errCount++;
            errMsg = "Please Select Charge Setting";
          }
        });

        if (errCount > 0) {
          if (showErr) {
            this.$toasted.show(errMsg);
          }
          return false;
        } else {
          return true;
        }
      },

      validateCombo(showErr = true) {
        let errorCount = 0;
        let errorMsg = "";

        if (this.fnb_item.is_combo == "Y") {
          this.CinemaPriceSettings.forEach((x) => {
            x.combo_pack.forEach((y) => {
              if (!y.category_id) {
                errorCount++;
                errorMsg = "Please Select Combo Category";
              } else if (!y.default_item_id) {
                errorCount++;
                errorMsg = "Please Select item in Combo";
              } else if (!y.quantity || isNaN(y.quantity)) {
                errorCount++;
                errorMsg = "Please Select Valid item Quantity in Combo";
              } else if (
                y.min_max_setting == "Y" &&
                isNaN(String(y.min_quantity))
              ) {
                errorCount++;
                errorMsg = "Please Select Valid Min item Quantity in Combo";
              } else if (
                y.min_max_setting == "Y" &&
                isNaN(String(y.max_quantity))
              ) {
                errorCount++;
                errorMsg = "Please Select Valid Max item Quantity in Combo";
              }
            });
          });
        }

        if (errorCount > 0) {
          if (showErr) {
            this.$toasted.show(errorMsg);
          }
          return false;
        } else {
          return true;
        }
      },
      onFinalSubmit: function(flag) {
        // let loader = this.$loading.show();
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          console.log("valid :", valid);
          if (this.fnb_item.item_image_url == "" && false) {
            // this.errmsg = "Please Select Food Image.";
            // return;
          } else if (!this.validateCombo()) {
            return;
          } else {
            if (valid) {
              let loader = this.$loading.show();
              // if (this.fnb_item.item_is_veg == true) {
              //   this.fnb_item.includes_egg = false;
              // }
              let payload = {
                CinemaPriceSettings: this.CinemaPriceSettings,
                removedPriceDetails: this.removedPriceDetails,
                fnb_item: {
                  ...this.fnb_item,
                  selected_alternate_items: this.selected_alternate_items,
                  removed_alternate_items: this.removed_alternate_items,
                },
                FnbItemContent: this.FnbItemContent,
                FnbCustomizations: this.customizationMap,
                RemovedCustomizations: this.removedCustomizations,
              };
              PosFnbService.UpdateFnbItem(payload)
                .then((response) => {
                  const { data } = response;
                  // loader.hide();
                  if (data && data.status) {
                    this.onResetForm();
                    this.$toasted.show(data.message);
                    this.$router.push({
                      path: "/fnb/fnb-items",
                    });
                  } else {
                    this.$toasted.show(data.message);
                  }
                })
                .catch(this._CatchError)
                .finally(() => {
                  loader.hide();
                });
            }
          }
        });
      },
      CheckEmptyContent: function(fnbContent, index) {
        console.log("im in");
        if (fnbContent.langauge.toLowerCase() !== "english") {
          if (fnbContent.item_name && fnbContent.item_description) {
            this.notempty[index] = true;
          } else {
            this.notempty[index] = false;
          }
        }
      },
    },
  };
</script>

<style>
  .clearDropDownBtn {
    position: absolute;
    left: 87%;
    z-index: 9999;
    width: auto;
    border: none;
    height: auto;
    font-size: 14px;
    color: #000000;
    font-weight: bold;
    background-color: transparent;
  }

  .section-collapse-box {
    border: 1px solid var(--lightgrey);
    border-radius: 10px;
    padding: 10px;
  }

  .customization-section-new .section-title {
    font-size: 22px;
  }

  .fnb-btn-edit {
    border-radius: 4px;
    border: 1px solid white;
    background-color: var(--blue);
    color: white;
    padding: 5px 25px;
  }
  .fnb-btn-edit:active {
    background-color: var(--blue);
    border: 1px solid var(--blue);
    color: white;
  }
  label {
    color: black;
  }
  .vat_value {
    border: none;
    background-color: white;
    border: 1px solid #d3d3d3;
    border-radius: 10px;
    padding: 5px 20px;
  }
  table,
  th,
  td {
    /*border: 1px solid black;*/
  }
  td {
    padding: 4px 10px;
  }
  .sec-1 {
    border: none;
    background: white;
    border-radius: 8px;
    padding: 15px 0px;
  }
  .border-new {
    border: 1px solid #d3d3d3;
    border-radius: 8px;
  }
  .main_border_edit td {
    border: 1px solid black;
  }
  .new-border {
    border: 2px solid #b1b4b8;
  }
  label {
    color: black !important;
  }
  .internal-border-new {
    border: 1px solid var(--blue);
    /*background-color: #e6e6f8;*/
  }
  .internal-border {
    border: 1px solid var(--blue);
    background-color: #e6e6f8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
  }
  .fs {
    font-size: 17px;
  }
  .back {
    background-color: #fff;
  }
  .mar {
    margin-left: 30px;
  }
  .border-left {
    border-left: 1px solid #b1b4b8;
  }
  .combo-box {
    padding: 17px;
    margin-bottom: 10px;
    background: #d3d3d342;
    border-radius: 15px;
  }

  .combo-inner-title {
    line-height: 1;
    font-size: 17px;
    font-weight: 500;
    color: var(--lightgrey);
    text-transform: capitalize;
  }
  .noCategory {
    height: 65px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border: 1px dotted grey;
  }
  .fnb-flag {
    margin-right: 27px;
    /* margin-bottom: 10px; */
  }

  .old_price_backup_combo tr td {
    padding: 4px 10px;
    color: black;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnBComponents/editFnbItem.vue